var _path, _path2, _path3, _path4, _path5, _polyline, _path6, _path7, _path8, _path9, _polygon, _polygon2, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncCostomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.29,
    y: 20,
    width: 81.44,
    height: 153.68,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.94,
    y: 20,
    width: 81.44,
    height: 153.68,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7,164.21s0-.23,0-.68,0-1.1,0-2c0-1.73,0-4.28,0-7.58,0-6.61,0-16.23-.07-28.33,0-24.18-.07-58.26-.12-97.88l.25.25H146.5l.26-.26c0,53.08,0,101.24-.07,136.43l-.19-.19,44,.1,12,0,3.13,0,1.08,0-1,0-3.1,0-11.95.05-44.11.1h-.18v-.19c0-35.19,0-83.35-.08-136.43v-.26H207v.25c0,39.69-.09,73.82-.12,98.05,0,12.07-.05,21.68-.07,28.27,0,3.28,0,5.81,0,7.53,0,.84,0,1.49,0,1.93S206.7,164.21,206.7,164.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.43,96.84a3,3,0,1,1-3-3A3,3,0,0,1,200.43,96.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.95,
    y: 20.31,
    width: 188.63,
    height: 153.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.3,
    y: 20.31,
    width: 162.46,
    height: 153.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,163.61s0-.22,0-.65,0-1.07,0-1.9c0-1.69,0-4.17,0-7.4,0-6.48,0-16-.05-28,0-24.12-.07-58.58-.12-99.93l.23.23L277.84,26h0l.26-.26c0,50.46,0,97.78,0,137.92l-.22-.22,101.52.11,28.51.06,7.53,0H418l-.64,0h-1.91l-7.49,0-28.46.05-101.66.12h-.23v-.23c0-40.14,0-87.46,0-137.92v-.26h.27l140.15,0h.22v.22c0,41.41-.09,75.92-.11,100.07,0,12-.05,21.52-.06,28,0,3.22,0,5.68,0,7.36,0,.82,0,1.45,0,1.88S418,163.61,418,163.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.75,174c-.15,0-.26-34.48-.26-77s.11-77,.26-77,.26,34.47.26,77S349.89,174,349.75,174Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.77,97.79a3.13,3.13,0,1,1-3.13-3.14A3.13,3.13,0,0,1,362.77,97.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.47,97.79a3.13,3.13,0,1,1-3.13-3.14A3.13,3.13,0,0,1,342.47,97.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.36,
    y: 20.31,
    width: 188.63,
    height: 153.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.71,
    y: 20.31,
    width: 162.46,
    height: 153.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.39,163.61s0-.22,0-.65,0-1.07,0-1.9c0-1.69,0-4.17,0-7.4,0-6.48,0-16-.06-28,0-24.12-.07-58.58-.11-99.93l.22.23L442.24,26h0l.26-.26c0,50.46,0,97.78,0,137.92l-.23-.22,101.52.11,28.51.06,7.53,0h2.6l-.64,0h-1.91l-7.48,0-28.46.05-101.67.12H442v-.23c0-40.14,0-87.46,0-137.92v-.26h.27l140.15,0h.23v.22c0,41.41-.09,75.92-.12,100.07,0,12,0,21.52-.06,28,0,3.22,0,5.68,0,7.36,0,.82,0,1.45,0,1.88S582.39,163.61,582.39,163.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.15,174c-.14,0-.26-34.48-.26-77s.12-77,.26-77,.26,34.47.26,77S514.29,174,514.15,174Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.18,97.79a3.13,3.13,0,1,1-3.13-3.14A3.13,3.13,0,0,1,527.18,97.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.87,97.79a3.13,3.13,0,1,1-3.13-3.14A3.13,3.13,0,0,1,506.87,97.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.94,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.08,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.21,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.34,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.47,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.73,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.86,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.99,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.12,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.25,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.39,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.94,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.08,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.21,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.34,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.47,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.73,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.86,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.99,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.12,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.25,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.39,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.94,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.08,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.55,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.69,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.55,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.69,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.55,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.69,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.21,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.34,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.47,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.73,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.86,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.99,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.12,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.25,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.39,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.03,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.16,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.42,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.55,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.68,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.81,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.94,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.07,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.21,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.34,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.47,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.03,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.16,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.42,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.55,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.68,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.81,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.94,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.07,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.21,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.34,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.47,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.03,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.16,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.42,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.55,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.68,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.81,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.94,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.07,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.21,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.34,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.47,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.04,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.04,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.04,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.13,
    y: 188.19,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.13,
    y: 213.39,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.13,
    y: 238.58,
    width: 22.31,
    height: 22.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.73,
    y: 75.38,
    width: 92.62,
    height: 60.89,
    transform: "translate(587.21 798.87) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 649.86,
    y: 78.01,
    width: 86.13,
    height: 55.68,
    transform: "translate(587.07 798.78) rotate(-90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.99,
    y: 98.19,
    width: 28.1,
    height: 15.32,
    transform: "translate(587.19 798.89) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.35,
    y: 91.66,
    width: 75.9,
    height: 49.9,
    transform: "translate(148.61 233.22) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.03,
    y: 93.89,
    width: 70.58,
    height: 45.63,
    transform: "translate(148.64 233.41) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.81,
    y: 110.33,
    width: 23.02,
    height: 12.56,
    transform: "translate(148.65 233.22) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723.17,461.33c0,.14-156.34.26-349.15.26s-349.19-.12-349.19-.26,156.31-.27,349.19-.27S723.17,461.18,723.17,461.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "575.13 259.94 577.35 283.9 592.43 283.9 594 259.54 575.13 259.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.13,259.94a1.15,1.15,0,0,1,.32,0l1-.05,3.8-.13,13.76-.41h.24l0,.24c-.4,6.42-.87,14.08-1.38,22.31-.05.69-.09,1.38-.14,2.06v.24h-.24l-15.09,0h-.22l0-.22c-.61-7.08-1.12-13.09-1.49-17.38-.16-2.06-.29-3.71-.38-4.9,0-.52-.07-.95-.1-1.28a3.29,3.29,0,0,1,0-.42,2.6,2.6,0,0,1,.07.47c0,.35.09.78.15,1.33.13,1.19.3,2.86.52,4.94.42,4.25,1,10.19,1.71,17.2l-.23-.21,15.09,0-.26.25c0-.69.08-1.37.13-2.06.54-8.23,1-15.89,1.47-22.3l.22.23-13.62.17-3.85,0h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,265.32c-.24,0,1.53,15.83,1.53,15.83h12.6l1.39-15.83s-5.74,1.69-7.91,1.69S581.33,264.93,577,265.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "587.99 266.48 592.47 246.06 601.71 242.52 602.38 244.34 594.75 247.62 590.39 265.89 587.99 266.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.17,248.22s-22.37.68-24.78,28.86l12.76,4.07-1.85,43L655,325.38,654.09,280l.62-7c.71-16.6,1.47-22.47-12.73-24.29-.36,0-3-.09-3.36-.1l-17.92-.37",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.84,283.62a90,90,0,0,1-.26-9.6,89.72,89.72,0,0,1,.26-9.59,86.68,86.68,0,0,1,.26,9.59A86.94,86.94,0,0,1,607.84,283.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.88,208v3l.76,38.7c0,5.18-3.24,7.46-8.87,7.44h0c-5.68,0-9.18-1.57-9.29-6.8-.12-5.49-.35-6.2-.35-6.2s-7.2-1.06-8.86-10.26c-.82-4.58-.73-12.11-.45-18.27a9.84,9.84,0,0,1,10.75-9.27Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.47,221.75a1.17,1.17,0,0,0,1.14,1.16,1.11,1.11,0,0,0,1.17-1.07,1.14,1.14,0,0,0-1.13-1.15A1.1,1.1,0,0,0,613.47,221.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,220.69c.14.14,1-.52,2.26-.54s2.18.59,2.31.43-.08-.34-.49-.62a3.25,3.25,0,0,0-1.85-.54,3.07,3.07,0,0,0-1.8.62C613.06,220.34,612.94,220.62,613,220.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.3,221.75a1.17,1.17,0,0,0,1.14,1.16,1.12,1.12,0,0,0,1.18-1.07,1.15,1.15,0,0,0-1.14-1.15A1.1,1.1,0,0,0,625.3,221.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.29,220.7c.15.15,1-.52,2.27-.54s2.17.59,2.31.44-.09-.34-.49-.63a3.2,3.2,0,0,0-1.85-.53,3.07,3.07,0,0,0-1.8.62C625.35,220.36,625.22,220.63,625.29,220.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.08,229.44a7.66,7.66,0,0,0-1.91-.31c-.3,0-.59-.08-.64-.29a1.47,1.47,0,0,1,.18-.89c.27-.73.55-1.5.85-2.3a38,38,0,0,0,1.88-6,39.73,39.73,0,0,0-2.36,5.85l-.81,2.31a1.72,1.72,0,0,0-.14,1.18.78.78,0,0,0,.51.43,2.5,2.5,0,0,0,.51.06A7.64,7.64,0,0,0,621.08,229.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.22,218c-.09-.19.17-.54.74-.84a4.83,4.83,0,0,1,4.8.36c.52.38.72.77.6.94-.25.36-1.51-.1-3.07-.2S612.42,218.42,612.22,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.3,216.53c-.09-.19.17-.54.74-.84a4.63,4.63,0,0,1,2.45-.46,4.69,4.69,0,0,1,2.35.81c.52.39.72.77.61,1-.26.36-1.52-.11-3.08-.2S625.5,216.92,625.3,216.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.07,232.34a3.72,3.72,0,0,0,3.08-2.41c.08-.2.18-.45.39-.46a.48.48,0,0,1,.36.25,2.44,2.44,0,1,1-4,2.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "610.67 214.61 610.6 214.29 610.65 214.28 610.72 214.6 610.67 214.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.13,244.13a26.25,26.25,0,0,0,12.5-3.88s-3,7.2-12.4,6.49Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.12,226.86c1.77-2.57,2.06-4.82,2.92-7.82a22.2,22.2,0,0,0,.79-8.76c-.38-2.86,0-5.77-2-7.84a11.59,11.59,0,0,0-9.67-3.37,11.43,11.43,0,0,1-3.18.25c-1.47-.24-2.64-1.31-3.87-2.12a12.81,12.81,0,0,0-6.34-2.09,5.17,5.17,0,0,0-3.53.87,2.38,2.38,0,0,0-.51,3.28,4.09,4.09,0,0,0-3.88-1.26,3.56,3.56,0,0,0-2.7,3,3.17,3.17,0,0,0,2.16,3.3c-1.64-1.24-4.28-.33-5.18,1.51a5.31,5.31,0,0,0,1.1,5.7,10,10,0,0,0,5.39,2.77,17,17,0,0,0,15.88-4.84,7.38,7.38,0,0,0,6.62,4.41,36.93,36.93,0,0,0,.61,10,5.77,5.77,0,0,0,1.88,3.39,2.5,2.5,0,0,0,3.5-.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637,219.73c.14-.07,5.63-1.93,5.69,3.75S637,228,637,227.88,637,219.73,637,219.73Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.7,225.71s.1.07.27.15a1,1,0,0,0,.74,0,2.44,2.44,0,0,0,1.11-2.21,3.23,3.23,0,0,0-.29-1.41,1.15,1.15,0,0,0-.75-.75.5.5,0,0,0-.58.28c-.08.16,0,.27-.07.28s-.12-.09-.08-.33a.64.64,0,0,1,.22-.36.74.74,0,0,1,.54-.15,1.42,1.42,0,0,1,1.05.87,3.38,3.38,0,0,1,.36,1.58,2.58,2.58,0,0,1-1.42,2.47,1.07,1.07,0,0,1-.91-.14C638.72,225.85,638.68,225.72,638.7,225.71Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.79,264.83a21.5,21.5,0,0,1-2.68-3.88,21.79,21.79,0,0,1-2.23-4.16,42.83,42.83,0,0,1,4.91,8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.77,272.44a14.63,14.63,0,0,1-3.26,2.17,15.38,15.38,0,0,1-3.51,1.72,14.13,14.13,0,0,1,3.25-2.17A15.34,15.34,0,0,1,629.77,272.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.56,267.15a26,26,0,0,1-2.74-6.8,13.23,13.23,0,0,1,1.61,3.3A12.81,12.81,0,0,1,648.56,267.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.48,294.57c-.12.1-1.34-1.13-3-2.41s-3.19-2.15-3.12-2.28a8.74,8.74,0,0,1,3.44,1.86A9,9,0,0,1,652.48,294.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.81,314.51a34.41,34.41,0,0,1,.93-8.34,34.41,34.41,0,0,1-.93,8.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.22,305.39a8.07,8.07,0,0,1-3.13-.52,7.84,7.84,0,0,1-2.9-1.29,13.29,13.29,0,0,1,3,.79A12.29,12.29,0,0,1,651.22,305.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.13,315.89a11.19,11.19,0,0,1-4.62,4.94,24.1,24.1,0,0,1,2.31-2.47A23.31,23.31,0,0,1,648.13,315.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.61,312.9a17.79,17.79,0,0,1-3.13,2.92,18.24,18.24,0,0,1-3.47,2.52,35.83,35.83,0,0,1,6.6-5.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.58,305.24a7.88,7.88,0,0,1-1.19-2.61,8.4,8.4,0,0,1-.69-2.78,7.88,7.88,0,0,1,1.19,2.61A8.45,8.45,0,0,1,613.58,305.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.8,319a16.33,16.33,0,0,1-1.9-3.61,16,16,0,0,1-1.44-3.82A31.8,31.8,0,0,1,630.8,319Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.08,265.44a10.57,10.57,0,0,1-1.7,6.17,19.45,19.45,0,0,1,.83-3.09A17.18,17.18,0,0,1,603.08,265.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.18,274.38a16.48,16.48,0,0,1,.41,4.08,16.67,16.67,0,0,1-.11,4.1,15.77,15.77,0,0,1-.41-4.08A16.71,16.71,0,0,1,615.18,274.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.58,261.76a12.2,12.2,0,0,1-3.48-.62,12,12,0,0,1-3.34-1.12,24.22,24.22,0,0,1,6.82,1.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M607.84,293.28a47.14,47.14,0,0,0,16.95,14.23c2.82,1.44,6,2.64,9.09,2.13a11.91,11.91,0,0,0,7.1-4.49,35.31,35.31,0,0,0,4.27-7.43l4.89-10.37a31.51,31.51,0,0,0,1.79-6.63,7.83,7.83,0,0,0-2.88-1.41c-1-.2-.91.63-1.33,1.62a81.82,81.82,0,0,1-11.35,19c-1.19,1.49-2.64,3-4.53,3.19a7.2,7.2,0,0,1-3.61-1c-7.37-3.44-13-7.09-20.39-10.54"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M634.43,272.05l-7.29,16.1L602.7,273.79c-1.3-.86-5.37-3.35-6-3.94a7.24,7.24,0,0,1-1.57-2,13.42,13.42,0,0,1-1.15-2.61.71.71,0,0,1,0-.2.94.94,0,0,0-.12-.39,1,1,0,0,0-1.72-.19c-.37.73-.09,3,1.3,5.45l.06.12c1.35,2.48-2.69.76-4.18.17s-6.16-2.23-6.69-1.91c-.78.46-.42,1.41,1.07,2s5.87,2.56,5.54,3.34-7.84-2.38-7.84-2.38-1.51-.94-1.92-.05c-.75,1.59,7.47,4.34,8.26,4.58.55.17.22,1-.36.81s-7.43-3.31-8.21-1.7c-.59,1.24,6.75,2.33,7.83,3.76s-5.49-1.39-6-.19c-.2.45-.28.82,3.72,1.89,2.15.58,10.25,1.65,10.25,1.65h0l1.77,1.19h0s26.9,21.68,36,21.67c6,0,16.42-25.52,16.42-25.52Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.85,281.17a1.85,1.85,0,0,1-.41-.15l-1.15-.52-4.23-2-14.35-7-.19-.09.05-.21.85-3.2h0l.81-2.27a37.88,37.88,0,0,1,2.27-5.22,30.54,30.54,0,0,1,3-4.41,14.26,14.26,0,0,1,3.58-3.23,10.05,10.05,0,0,1,4-1.29,6.82,6.82,0,0,1,3.43.5,7.05,7.05,0,0,1,2.14,1.52,9,9,0,0,1,1,1.3,2.19,2.19,0,0,1,.27.5s-.43-.67-1.44-1.65a6.85,6.85,0,0,0-2.1-1.4,6.64,6.64,0,0,0-3.28-.41,9.86,9.86,0,0,0-3.82,1.3,13.59,13.59,0,0,0-3.43,3.17,30,30,0,0,0-2.89,4.34,38.93,38.93,0,0,0-2.23,5.16l-.81,2.26v0c-.3,1.1-.58,2.18-.86,3.2l-.13-.29,14.28,7.17,4.16,2.15,1.11.6A1.78,1.78,0,0,1,652.85,281.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.93,419.1l-2.33-7.23,13.52-4.46L585.64,418l-.82.33c-3.66,1.43-18.72,7-21.46,7.11C560.3,425.47,570.93,419.1,570.93,419.1Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M580.71,419.47a4.93,4.93,0,0,1,.77-3.45,4.77,4.77,0,0,1,2.84-2l1.24,3.78Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M565.8,422.42s-3.64,2.48-2.92,3S579,420.8,585.64,418l-.12-.3-17.95,6.1S566.6,422.19,565.8,422.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M585.73,417.58l-.22.11-.66.26-2.42.91c-2,.76-4.9,1.78-8.06,2.83s-6.06,1.93-8.16,2.54l-2.49.71-.68.19-.24.05.23-.09.67-.21,2.48-.76c2.08-.65,5-1.55,8.13-2.6s6-2,8.08-2.77l2.44-.87.66-.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.64,424a5.45,5.45,0,0,0-.84-1,5.54,5.54,0,0,0-1.15-.66,1.82,1.82,0,0,1,1.26.53A1.88,1.88,0,0,1,567.64,424Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571,420.63s-.29-.13-.59-.38-.52-.47-.49-.51.3.13.6.38S571,420.59,571,420.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.87,419.69s-.28,0-.58-.16-.54-.28-.52-.32.28,0,.58.16S571.89,419.65,571.87,419.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.14,418.19a1.8,1.8,0,0,1-.68.32,1.82,1.82,0,0,1-.73.16c0-.05.29-.19.68-.32S572.12,418.14,572.14,418.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.08,417.21a1.55,1.55,0,0,1-.71.49,1.58,1.58,0,0,1-.85.16,4.66,4.66,0,0,1,.78-.32A4.3,4.3,0,0,1,572.08,417.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.12,419.6a2.7,2.7,0,0,1-.87.28,5.55,5.55,0,0,1-1,.11,3.23,3.23,0,0,1-.6-.05.52.52,0,0,1-.3-.2.37.37,0,0,1,0-.39,1.69,1.69,0,0,1,2.13-.18,1.59,1.59,0,0,1,.47.48c.09.14.11.23.1.23a2.42,2.42,0,0,0-.64-.61,1.65,1.65,0,0,0-.9-.24,1.4,1.4,0,0,0-1,.42c-.1.14,0,.29.19.33a3.31,3.31,0,0,0,.55.05,6.67,6.67,0,0,0,1-.07C569.78,419.68,570.11,419.58,570.12,419.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.9,419.72a1,1,0,0,1-.29-.57,1.44,1.44,0,0,1,0-.71.89.89,0,0,1,.58-.68.36.36,0,0,1,.4.31,1,1,0,0,1,0,.43,2.61,2.61,0,0,1-.24.67,1.26,1.26,0,0,1-.38.51s.12-.21.27-.57a2.85,2.85,0,0,0,.2-.64c0-.22,0-.58-.2-.54s-.38.34-.45.55a1.37,1.37,0,0,0-.06.65A5.08,5.08,0,0,0,569.9,419.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.23,414s-.4.09-1,.36a4.44,4.44,0,0,0-2.61,4c0,.65.09,1.05.06,1.05s-.05-.09-.09-.27a3.55,3.55,0,0,1-.09-.78,4.38,4.38,0,0,1,.7-2.46,4.44,4.44,0,0,1,2-1.64A3.76,3.76,0,0,1,584,414,.75.75,0,0,1,584.23,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581,408.82a23.69,23.69,0,0,1,1,2.73,27.47,27.47,0,0,1,.87,2.8,24.35,24.35,0,0,1-1-2.74A28.71,28.71,0,0,1,581,408.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.57,418.71a11.51,11.51,0,0,1-3.94,1.34c0-.05.89-.28,2-.65S578.55,418.67,578.57,418.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.22,417.83s0,.21,0,.45,0,.42-.06.44-.14-.19-.11-.46S581.18,417.81,581.22,417.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.8,416.26c.05,0,0,.19-.09.38s-.2.32-.24.3,0-.19.09-.38S581.76,416.24,581.8,416.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.05,415.22s-.18.11-.35.24-.29.29-.33.27,0-.24.22-.4S583.05,415.17,583.05,415.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584,414.62s0,.13-.12.21-.2.11-.23.08,0-.13.12-.21S583.94,414.58,584,414.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.22,401l-4.54-6.09L623,386.29l6.75,8.84-.67.58c-3,2.54-15.45,12.71-18,13.66C608.22,410.43,616.22,401,616.22,401Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M625.59,398.15a5,5,0,0,1-.38-3.51,4.78,4.78,0,0,1,2-2.84l2.4,3.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M612.44,405.76s-2.65,3.53-1.8,3.77,13.8-9.57,19.14-14.4l-.22-.24-15,11.57S613.12,405.28,612.44,405.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M629.74,394.75l-.18.17-.54.45L627,397c-1.7,1.39-4.06,3.26-6.72,5.28s-5.11,3.79-6.9,5.05l-2.12,1.47-.59.39-.21.13.19-.16.57-.41,2.09-1.52c1.77-1.29,4.21-3.07,6.86-5.09s5-3.87,6.75-5.23l2-1.61.56-.43C629.66,394.79,629.73,394.74,629.74,394.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.68,406.63a5.57,5.57,0,0,0-1.13-.69,6.65,6.65,0,0,0-1.3-.26,2,2,0,0,1,1.37.1A1.89,1.89,0,0,1,614.68,406.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.75,402.4a1.55,1.55,0,0,1-.69-.17,1.63,1.63,0,0,1-.63-.32c0-.05.33,0,.69.16S616.76,402.35,616.75,402.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.3,401.22a1.22,1.22,0,0,1-.6,0c-.33,0-.6-.09-.59-.13s.27-.07.6,0S617.3,401.17,617.3,401.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.07,399.71s-.21.27-.54.52a1.82,1.82,0,0,1-.64.39s.21-.27.54-.53S617,399.67,617.07,399.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.7,398.8a1.61,1.61,0,0,1-.52.69,1.48,1.48,0,0,1-.75.43c0-.05.29-.25.64-.56S616.65,398.77,616.7,398.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.61,401.7a2.84,2.84,0,0,1-.73.55,5.22,5.22,0,0,1-.91.41,2.33,2.33,0,0,1-.58.16.51.51,0,0,1-.35-.09.37.37,0,0,1-.11-.38,1.68,1.68,0,0,1,2-.86,1.65,1.65,0,0,1,.6.31c.13.1.18.17.17.18a2.52,2.52,0,0,0-.8-.37,1.6,1.6,0,0,0-.93.07,1.4,1.4,0,0,0-.82.71c-.06.18.09.28.28.26a2,2,0,0,0,.54-.14,5.57,5.57,0,0,0,.9-.37C615.32,401.89,615.6,401.68,615.61,401.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.45,401.88s-.25-.09-.47-.44a1.52,1.52,0,0,1-.2-.69.92.92,0,0,1,.33-.83.36.36,0,0,1,.47.17,1,1,0,0,1,.13.42,2.69,2.69,0,0,1,0,.7,1.22,1.22,0,0,1-.2.61s0-.24.08-.62a3.17,3.17,0,0,0,0-.67c0-.23-.16-.56-.37-.45a.82.82,0,0,0-.24.67,1.5,1.5,0,0,0,.15.63A3.08,3.08,0,0,0,615.45,401.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.16,391.82a8.59,8.59,0,0,0-.82.66,4.46,4.46,0,0,0-1.18,4.62c.2.62.43,1,.4,1s-.08-.07-.18-.22a4.45,4.45,0,0,1-.33-.71,4.35,4.35,0,0,1-.14-2.56,4.43,4.43,0,0,1,1.35-2.19,3.84,3.84,0,0,1,.63-.46C627.06,391.84,627.15,391.81,627.16,391.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.4,388A47.64,47.64,0,0,1,626,392.6a26.64,26.64,0,0,1-1.86-2.25A27.46,27.46,0,0,1,622.4,388Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.32,398.13a7.58,7.58,0,0,1-1.53,1.41,8.08,8.08,0,0,1-1.76,1.13s.75-.56,1.66-1.26S623.29,398.09,623.32,398.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.55,396.44c.05,0,.06.2.11.43s.12.41.08.44-.19-.14-.25-.4S625.5,396.43,625.55,396.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.6,394.76s.06.18,0,.39-.09.37-.13.36-.07-.18,0-.38S625.55,394.76,625.6,394.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.43,393.38s-.13.15-.25.34-.17.36-.22.36-.08-.23.08-.46S626.42,393.33,626.43,393.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.12,392.51s0,.13,0,.24-.15.17-.19.15,0-.14,0-.24S627.08,392.48,627.12,392.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.18,353.91,609.38,402l18.26-13.78L598.91,343l-20.73-2.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.25 461.88 674.12 461.88 674.12 235.28 666.86 235.28 664.25 461.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.76,347.19H656a8.22,8.22,0,0,1,8.22,8.22V357a8.22,8.22,0,0,1-8.22,8.22H581.76a0,0,0,0,1,0,0v-18A0,0,0,0,1,581.76,347.19Z",
    transform: "translate(1246.02 712.42) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.85,
    y: 364.39,
    width: 6.01,
    height: 97.18,
    transform: "translate(1181.71 825.96) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.48,
    y: 415.29,
    width: 74.66,
    height: 3.14,
    transform: "translate(1259.63 833.72) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655,323.3l.1,5.47a18.22,18.22,0,0,1-17.69,18.58l-53.83,1.56,4.24,61.15-23.64,6.32-6.16-69.78a21.41,21.41,0,0,1,21.33-23.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "487.71 222.31 441.81 288.7 463.07 288.7 501.02 235.24 487.71 222.31",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.86,239.69h84.45a0,0,0,0,1,0,0v99.44a9.94,9.94,0,0,1-9.94,9.94H484.8a9.94,9.94,0,0,1-9.94-9.94V239.69A0,0,0,0,1,474.86,239.69Z",
    transform: "translate(1034.17 588.76) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.19,
    y: 348.64,
    width: 107.8,
    height: 18.21,
    rx: 8.3,
    transform: "translate(1034.17 715.49) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.19,
    y: 364.72,
    width: 5.56,
    height: 93.96,
    transform: "translate(959.93 823.39) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.4,
    y: 364.94,
    width: 6.92,
    height: 96.79,
    transform: "translate(1111.71 826.67) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.12,
    y: 413.79,
    width: 76.83,
    height: 4.57,
    transform: "translate(1039.08 832.15) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.37,182.51a2.11,2.11,0,0,0,2.94,2.53c1.4-.69,1.6-2.6,1.35-4.14s-.76-3.19-.1-4.6a10.32,10.32,0,0,1,2.43-2.6,6.75,6.75,0,0,0,1.93-5.69,5.66,5.66,0,0,0-3.83-4.5c-2-.59-4.57,0-6.07-1.49-1.09-1.09-1.14-2.85-2-4.14-1.3-2-4.1-2.35-6.47-2.06s-4.79,1-7.1.42c-1.93-.5-3.5-1.87-5.3-2.72a10.45,10.45,0,0,0-13.79,14.18c.71,1.39,2.11,5.38,6.55,5.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.29,165.91l-.06,3.18-.64,47.65c-.07,5.53-4.89,9.87-10.81,9.75h0c-6-.13-10.84-4.76-10.86-10.35,0-5.86-.14-12-.14-12s-7.56-1.25-9.12-11.11c-.78-4.91-.54-12.94-.12-19.52a10.4,10.4,0,0,1,11.48-9.7Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.56,179.07a1.26,1.26,0,0,0,1.22,1.28,1.21,1.21,0,0,0,1.3-1.14,1.27,1.27,0,0,0-1.22-1.28A1.2,1.2,0,0,0,497.56,179.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.28,177.66c.16.16,1.12-.55,2.48-.54s2.36.68,2.5.51-.08-.37-.52-.68a3.39,3.39,0,0,0-2-.62,3.27,3.27,0,0,0-2,.63C497.35,177.28,497.21,177.58,497.28,177.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.18,179.07a1.26,1.26,0,0,0,1.22,1.28,1.21,1.21,0,0,0,1.3-1.14,1.27,1.27,0,0,0-1.22-1.28A1.2,1.2,0,0,0,511.18,179.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.66,177.91c.15.16,1.11-.54,2.47-.54s2.36.68,2.51.52-.09-.37-.52-.69a3.47,3.47,0,0,0-2-.62,3.36,3.36,0,0,0-2,.64C510.72,177.54,510.58,177.84,510.66,177.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.72,188a9,9,0,0,0-2.21-.4c-.35,0-.68-.1-.74-.34a1.78,1.78,0,0,1,.24-1l1-2.65a45.1,45.1,0,0,0,2.31-6.92,47.08,47.08,0,0,0-2.86,6.72l-1,2.66a2,2,0,0,0-.18,1.37.87.87,0,0,0,.57.51,2.75,2.75,0,0,0,.59.08A8.85,8.85,0,0,0,505.72,188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.78,204.1a25.05,25.05,0,0,0,13.2-3.52s-3.2,6.77-13.07,5.85Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.72,188.94c-.22,0-.22,1.47-1.49,2.51s-2.83.89-2.84,1.1.35.28,1,.3a3.7,3.7,0,0,0,2.38-.83,3.19,3.19,0,0,0,1.15-2.1C510,189.3,509.82,188.93,509.72,188.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.31,172.58c.13.37,1.49.19,3.08.38s2.89.63,3.1.3c.1-.16-.13-.51-.65-.86a5.35,5.35,0,0,0-4.71-.52C510.54,172.11,510.25,172.4,510.31,172.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.78,173.72c.24.31,1.18,0,2.31,0s2.08.21,2.3-.11c.09-.16-.06-.47-.47-.76a3.23,3.23,0,0,0-1.88-.51,3.11,3.11,0,0,0-1.83.62C497.81,173.25,497.68,173.57,497.78,173.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.21,168.78s5,2.64,11.8-.47c4.43-2.05,9.55-2.95,10.65-2s1.19,5.42,5.47,6.87c0,0-.57,8.58,2.87,8.38s2.91-17.41,2.91-17.41l-9.44-.5-9.09-2-9.5,1.15-6.72,1.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.14,162c.05-.13-.76-.43-1.71-.09s-1.38,1.09-1.26,1.16.64-.4,1.44-.67S529.11,162.13,529.14,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.3,159.08c-.16,0-.11,1-.29,2.18s-.67,2-.55,2.1.87-.71,1.06-2A3.33,3.33,0,0,0,526.3,159.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.8,178.31c.14-.07,5.7-2,5.75,3.8s-5.72,4.62-5.73,4.45S525.8,178.31,525.8,178.31Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.55,184.37s.1.07.27.14a1,1,0,0,0,.75,0,2.46,2.46,0,0,0,1.12-2.24,3.29,3.29,0,0,0-.29-1.43,1.16,1.16,0,0,0-.76-.76.51.51,0,0,0-.59.28c-.08.16,0,.28-.07.29s-.12-.1-.08-.33a.63.63,0,0,1,.22-.37.79.79,0,0,1,.56-.15,1.42,1.42,0,0,1,1.05.88,3.43,3.43,0,0,1,.37,1.6,2.61,2.61,0,0,1-1.44,2.5,1.1,1.1,0,0,1-.92-.14C527.56,184.51,527.53,184.38,527.55,184.37Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.88,240.29S554.16,309,554,315.63l-71.76-.84,5.9-36.47,0-21.19-6.5,9.69-19.61-16.23,21-27h0a34.78,34.78,0,0,1,13.47-8.71,27.82,27.82,0,0,1,8.43-1.62h0a33.83,33.83,0,0,0,20.38,0c.82.11,2,.22,3.42.39l.26,0a26,26,0,0,1,22.72,24.47Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.33,254.86a84.47,84.47,0,0,1-.26-9.46,84.32,84.32,0,0,1,.26-9.46,87.29,87.29,0,0,1,.26,9.46A87.44,87.44,0,0,1,488.33,254.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.79,213.63s24.18.18,27.18,25.72l1.5,19-21.92-.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "533.82 235.69 530.34 266.17 538.18 270.9 537.41 257.94 535.29 257.9 533.82 235.69"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M415.94,397.6l4.52-9.35L438,396.61l-6.47,13.74-1.12-.45c-5-2-25.14-10.71-27.91-13.23C399.42,393.86,415.94,397.6,415.94,397.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,410.06l-.32-.11-.89-.36-3.26-1.38c-2.74-1.18-6.5-2.87-10.62-4.82s-7.81-3.8-10.46-5.18l-3.13-1.65-.85-.46-.28-.17a1.17,1.17,0,0,1,.31.13l.86.42,3.16,1.58c2.67,1.34,6.37,3.17,10.49,5.12s7.87,3.66,10.59,4.88l3.23,1.45.87.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.1,399.3a8.24,8.24,0,0,0,.13-1.8,7.72,7.72,0,0,0-.51-1.74,3.14,3.14,0,0,1,.38,3.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.53,399.14a2.06,2.06,0,0,1-.23-.94c-.07-.53-.07-1,0-1a2.17,2.17,0,0,1,.23.94C414.6,398.7,414.6,399.13,414.53,399.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.31,399.06c-.06,0-.25-.29-.42-.71s-.27-.77-.21-.79.25.29.43.7S416.37,399,416.31,399.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,397.83a2.2,2.2,0,0,1-1-.32,2.35,2.35,0,0,1-.88-.53,2.22,2.22,0,0,1,1,.32C417.63,397.53,418,397.77,418,397.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.86,396.81a2,2,0,0,1-1.16-.19c-.62-.24-1-.59-1-.64a102.69,102.69,0,0,0,2.15.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.66,397.32a3.56,3.56,0,0,1-1.12-.54,7.8,7.8,0,0,1-1.08-.84,3.69,3.69,0,0,1-.55-.61.63.63,0,0,1-.11-.48.48.48,0,0,1,.38-.37,2.33,2.33,0,0,1,2.29,2.75.85.85,0,0,1-.12.32,3.78,3.78,0,0,0-.06-1.21,2.16,2.16,0,0,0-.66-1.08,2,2,0,0,0-1.39-.55c-.24.05-.27.29-.13.5a3.93,3.93,0,0,0,.5.58,8.63,8.63,0,0,0,1,.85C414.25,397.08,414.68,397.29,414.66,397.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.35,397.24s-.06-.36.24-.85a2.06,2.06,0,0,1,.7-.67,1.24,1.24,0,0,1,1.21-.13.49.49,0,0,1,.1.68,1.32,1.32,0,0,1-.43.42,3.83,3.83,0,0,1-.86.43,2.06,2.06,0,0,1-.86.15s.32-.1.8-.31a4.15,4.15,0,0,0,.8-.45c.26-.17.57-.54.31-.73a1.1,1.1,0,0,0-1,.13,2,2,0,0,0-.66.58A4,4,0,0,0,414.35,397.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.92,405.09s-.48-.29-1.32-.57a6.21,6.21,0,0,0-3.39-.18,6.28,6.28,0,0,0-2.95,1.66c-.63.62-.9,1.12-.93,1.09s0-.13.16-.35a5.34,5.34,0,0,1,.65-.86,5.91,5.91,0,0,1,6.51-1.52,5.26,5.26,0,0,1,1,.48A1.37,1.37,0,0,1,433.92,405.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.57,396.91a33.18,33.18,0,0,1-1.56,3.68,33.89,33.89,0,0,1-1.78,3.59,33.18,33.18,0,0,1,1.56-3.68A33.89,33.89,0,0,1,435.57,396.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.86,404.42a11.11,11.11,0,0,1-2.69-1A11.6,11.6,0,0,1,418.7,402c0-.06,1.15.56,2.57,1.21S423.88,404.35,423.86,404.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.3,406.05c0,.06-.21.2-.45.41s-.42.41-.48.37,0-.32.33-.55S427.28,406,427.3,406.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.36,405.05c0,.06-.17.19-.44.29s-.51.13-.53.07.18-.19.45-.29S429.34,405,429.36,405.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.57,405.2c0,.05-.27-.06-.57-.09s-.56,0-.58-.05.23-.23.6-.19S431.61,405.15,431.57,405.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.06,405.48c0,.06-.15.1-.32.09s-.31-.08-.31-.14.15-.11.32-.09S433.06,405.41,433.06,405.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.85,456.72l.15-10.38,19.44.14-.05,15.19-1.2.07c-5.37.26-27.32.93-30.89-.18C453.3,460.31,469.85,456.72,469.85,456.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.67,461.23l-.33,0-1,.05-3.54.13c-3,.09-7.11.15-11.67.12s-8.69-.14-11.67-.26l-3.53-.18-1-.06-.34,0H457l1,0,3.54.1c3,.08,7.11.17,11.66.2s8.68,0,11.67-.06l3.53,0h1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.47,461.58a5.17,5.17,0,0,0-1.84-3.05,2.59,2.59,0,0,1,1.39,1.24A2.56,2.56,0,0,1,463.47,461.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.23,458.71c-.06,0-.33-.3-.61-.75a2.14,2.14,0,0,1-.41-.88c.06,0,.33.31.61.75A2.14,2.14,0,0,1,469.23,458.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.81,457.89c-.05.05-.35-.16-.68-.46s-.57-.59-.53-.64.35.16.69.46S470.85,457.84,470.81,457.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.82,456.06a2.39,2.39,0,0,1-1,.12,2.53,2.53,0,0,1-1-.11,2.22,2.22,0,0,1,1-.12A2.15,2.15,0,0,1,471.82,456.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.17,454.77a2,2,0,0,1-1.14.32,1.8,1.8,0,0,1-1.16-.17,7.79,7.79,0,0,1,1.15-.07A5.51,5.51,0,0,1,472.17,454.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.58,457a3.83,3.83,0,0,1-1.25,0,7.43,7.43,0,0,1-1.33-.3,4.29,4.29,0,0,1-.76-.32.64.64,0,0,1-.3-.39.49.49,0,0,1,.19-.5,2.3,2.3,0,0,1,3.23,1.53.75.75,0,0,1,0,.34,3.26,3.26,0,0,0-.56-1.07,2.22,2.22,0,0,0-1.06-.7,1.89,1.89,0,0,0-1.49.09c-.2.14-.13.38.09.51a3.6,3.6,0,0,0,.7.3,8.15,8.15,0,0,0,1.29.35C468.1,457,468.58,457,468.58,457Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.26,457.07a1.24,1.24,0,0,1-.14-.87,1.92,1.92,0,0,1,.35-.91,1.22,1.22,0,0,1,1-.63.49.49,0,0,1,.38.58,1.39,1.39,0,0,1-.21.56,3.71,3.71,0,0,1-.6.75,1.76,1.76,0,0,1-.72.5s.25-.22.6-.62a4.3,4.3,0,0,0,.53-.74c.17-.27.29-.74,0-.8s-.64.28-.83.53a2,2,0,0,0-.36.81A4,4,0,0,0,468.26,457.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.31,455.9c0,.05-.56,0-1.44.05a6.18,6.18,0,0,0-3.14,1.27,6.26,6.26,0,0,0-2,2.75c-.3.83-.33,1.39-.38,1.39a1.26,1.26,0,0,1,0-.4,4.62,4.62,0,0,1,.22-1,5.9,5.9,0,0,1,5.26-4.14,5.72,5.72,0,0,1,1.07,0A1.38,1.38,0,0,1,489.31,455.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.35,447.8a32.19,32.19,0,0,1,.14,4,34.13,34.13,0,0,1-.09,4,32.19,32.19,0,0,1-.14-4A34.13,34.13,0,0,1,487.35,447.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.91,459.55a15.64,15.64,0,0,1-5.68,0c0-.07,1.27,0,2.84,0S479.9,459.49,479.91,459.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.72,459.57c0,.05-.1.27-.24.56s-.2.55-.27.55-.1-.31.06-.65S483.68,459.53,483.72,459.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.17,457.8c.05,0-.08.24-.28.45s-.41.33-.45.28.08-.25.28-.45S485.12,457.75,485.17,457.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.23,457c0,.07-.27.07-.56.17s-.49.24-.54.2.11-.31.47-.43S487.25,456.93,487.23,457Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.7,456.62c0,.06-.09.16-.25.22s-.32.06-.34,0,.09-.16.25-.22S488.67,456.56,488.7,456.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.27,316.34s-89.11-26-97.15-22.19-41.38,97-41.38,97L438.3,403.6l32.53-79.5s63.3,24.64,73.45,22.55S551.27,316.34,551.27,316.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.66,313.7c-1.27.42-50.12,16.41-53.51,22.74s1.59,120.11,1.59,120.11l31.72-.06L491.31,348.1l53.48-1.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.07,346.75a3.52,3.52,0,0,1-.79-.1l-2.23-.4c-1.94-.35-4.74-.91-8.18-1.65-6.89-1.46-16.38-3.67-26.71-6.64-5.17-1.51-10.05-3.07-14.45-4.59s-8.32-3-11.56-4.42c-1.64-.67-3.09-1.32-4.36-1.9s-2.37-1.08-3.25-1.53l-2-1a3.61,3.61,0,0,1-.68-.39,4,4,0,0,1,.74.28l2.07.92c.89.41,2,.89,3.29,1.43s2.74,1.17,4.38,1.81c3.26,1.33,7.2,2.75,11.59,4.28s9.28,3,14.43,4.53c10.32,3,19.77,5.25,26.64,6.82L542.1,346l2.2.51A3.73,3.73,0,0,1,545.07,346.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.41,361.51a8.21,8.21,0,0,1-.25-1.58l-.45-4.31c-.17-1.87-.37-4-.58-6.41a28.8,28.8,0,0,1,0-7.93,12.4,12.4,0,0,1,4-6.85,20.94,20.94,0,0,1,5.47-3.5c1.68-.76,3.09-1.25,4.06-1.59a8.07,8.07,0,0,1,1.53-.44c.05.11-2.11.86-5.4,2.43a21.78,21.78,0,0,0-5.27,3.52,12.09,12.09,0,0,0-3.77,6.55,30.21,30.21,0,0,0,0,7.77c.17,2.38.32,4.54.45,6.41s.19,3.18.25,4.33A7.93,7.93,0,0,1,459.41,361.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.47,265.67l27.35,24.85c6.56,6,18.45,7.45,25.82,2.54,4.42-2.95,5.31-8.35,6.2-13.59,1.65-9.67.28-21.14.28-21.14l-19.71-.39.55,12.53L505,251.85l-.59-.72c-.37-.92-.77-2-1.18-3.32a10.48,10.48,0,0,1-.48-3.52,19.11,19.11,0,0,1,.47-4,2.31,2.31,0,0,1,.1-.28,1.46,1.46,0,0,0-1.8-2c-1,.6-2.27,3.58-2.29,7.46a1,1,0,0,0,0,.18c-.13,3.93-3.78-1-5.13-2.75s-5.82-7-6.69-7c-1.26,0-1.5,1.39-.1,3.12s5.23,7.23,4.29,7.93-7.74-8.41-7.74-8.41-1.15-2.18-2.27-1.42c-2,1.39,5.91,10.5,6.68,11.35.54.59-.46,1.38-1,.72s-6.58-9.23-8.65-7.84c-1.59,1.06,6.46,7.56,6.74,10s-5.61-5.57-7.09-4.48c-.55.4-.9.78,3.13,4.9a124.53,124.53,0,0,0,10.41,8.68Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.47,258.33a1.57,1.57,0,0,1-.42,0l-1.22,0-4.59,0-16-.22h-.22l0-.23c-.24-3.64-.51-7.63-.79-11.8-.3-4.69-.63-9.14-.82-13.22a22.37,22.37,0,0,1,.45-5.81,11.73,11.73,0,0,1,2.15-4.6,7.81,7.81,0,0,1,3.34-2.52,7.14,7.14,0,0,1,3.14-.45,5.37,5.37,0,0,1,1.92.54,3,3,0,0,1,.45.26c.1.07.15.1.14.11a6.69,6.69,0,0,0-2.53-.7,6.82,6.82,0,0,0-3,.51,7.57,7.57,0,0,0-3.16,2.48,11.42,11.42,0,0,0-2,4.47,22.28,22.28,0,0,0-.39,5.69c.22,4,.56,8.52.86,13.21.27,4.16.52,8.15.76,11.8l-.24-.23,16,.41,4.58.16,1.22.06A2,2,0,0,1,557.47,258.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.68,241.57h84.45a0,0,0,0,1,0,0V341a9.94,9.94,0,0,1-9.94,9.94H339.62a9.94,9.94,0,0,1-9.94-9.94V241.57A0,0,0,0,1,329.68,241.57Z",
    transform: "translate(743.81 592.53) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.01,
    y: 350.52,
    width: 107.8,
    height: 18.21,
    rx: 8.3,
    transform: "translate(743.81 719.26) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.69 269.74 333.22 324.27 344.15 327.42 350.41 286.55 350.94 278.98 340.69 269.74",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.62,260.12A13.86,13.86,0,0,0,411.49,251l6.87-20,11.22,3.35-9,29.78a13.84,13.84,0,0,1-9.78,9l-14.6,3.62-2.92-15.48Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.4,234.75h0l.18-.37a91.1,91.1,0,0,0,3.83-9.22c1.2-4,.85-4.08.36-4.15-1.3-.2-2.37,6.88-3,5.2s2.3-8.48.94-8.63c-1.78-.19-2.76,7.25-2.89,7.87s-1,1.88-.88,1.33c.21-.8,2.22-10.68.47-10.89-1-.12-1,1.65-1,1.65s-1.3,8.05-2.12,7.92-.23-4.88.08-6.46-.3-2.37-1.1-2c-.55.29-1.63,5.12-1.91,6.7s-1,5.91-2.35,3.45l-.07-.11c-1.31-2.45-3.13-3.91-3.94-4a1,1,0,0,0-.48,1.86l.15.15a13.47,13.47,0,0,1,1.61,2.35,7.54,7.54,0,0,1,.87,2.39c.17,1,.29,1.82.36,2.53",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.36,256.05s-20.08.6-22.26,25.9l14.69,2.16-3.11,38.06,40.62-.59,1.44-42.53,1.21-3.76c2.79-8.69-3-18.05-12.12-18.82-.32,0-.64-.05-1-.05l-18.14-.37",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.17,256.65s17.49,2.19,24.42.51l2.48,19.61c-.36.66-10.65,1.6-19,2.28s-8.34-20-8.34-20Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.22,324.27h0l-.15.39a92.26,92.26,0,0,0-3.07,9.49c-.87,4.05-.51,4.14,0,4.17,1.31.09,1.8-7.05,2.58-5.43s-1.61,8.64-.24,8.68c1.79.05,2.17-7.45,2.25-8.08s1-.51.88.05c-.14.82-1.46,9.38.3,9.45,1,0,.83-1.73.83-1.73s.65-8.12,1.47-8.06.63,4.84.44,6.45.49,2.34,1.26,1.85c.52-.33,1.21-5.23,1.36-6.82s.48-6,2.07-3.64l.07.11c1.5,2.34,3.43,3.65,4.25,3.65a1,1,0,0,0,.33-1.9,1.83,1.83,0,0,1-.16-.13,13.41,13.41,0,0,1-1.8-2.21,7.63,7.63,0,0,1-1.06-2.32c-.25-.95-.43-1.78-.56-2.49",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.32,235.19a10,10,0,0,1,4.84-8.84c2.08-1.2,4.66-1.65,6.25-3.48,2.07-2.38,1.64-6.13,3.14-8.93l2.5-2.51a6.85,6.85,0,0,1,6.88.07,8.42,8.42,0,0,1,3.71-3.26,8.25,8.25,0,0,1,8.3,1.13,11.1,11.1,0,0,0,3,2.21c1.58.54,3.27-.2,4.93-.4a8.15,8.15,0,0,1,8.66,7.35c.1,1.51-.21,3-.26,4.54a5.57,5.57,0,0,0,1.34,4.2c1.57,1.5,4.15,1.19,5.93,2.44a4.93,4.93,0,0,1,1.8,4.89,7.12,7.12,0,0,1-3,4.42,9.58,9.58,0,0,1,.32,12.31,9,9,0,0,1-11.95,1.32c-.77-.58-1.61-1.34-2.54-1.13s-1.26,1-1.74,1.65a8.41,8.41,0,0,1-8,3.35A8.54,8.54,0,0,1,369,251.2a3.26,3.26,0,0,1-.58,2.75,7.18,7.18,0,0,1-2.64,2A18.38,18.38,0,0,1,356,258.2a11.79,11.79,0,0,1-8.72-4.73,9.14,9.14,0,0,1-.51-9.81A10,10,0,0,1,341.32,235.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,218.65v2.68l-.68,34.75c0,4.65,2.91,6.7,8,6.68h0c5.11,0,8.25-1.41,8.35-6.11a33.51,33.51,0,0,1,.31-5.57s6.47-.94,7.95-9.21c.74-4.11.66-10.87.41-16.4a8.83,8.83,0,0,0-9.65-8.32Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.87,231a1,1,0,0,1-1,1,1,1,0,0,1-1.06-1,1,1,0,0,1,1-1A1,1,0,0,1,383.87,231Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.28,230c-.13.13-.91-.47-2-.49s-1.95.53-2.07.39.08-.3.44-.55a2.85,2.85,0,0,1,1.66-.49,2.8,2.8,0,0,1,1.62.56C384.24,229.73,384.35,230,384.28,230Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,231a1,1,0,0,1-1,1,1,1,0,0,1-1.06-1,1,1,0,0,1,1-1A1,1,0,0,1,373.25,231Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,230.05c-.13.13-.91-.46-2-.48s-2,.53-2.07.39.07-.31.44-.56a2.85,2.85,0,0,1,1.66-.48,2.73,2.73,0,0,1,1.62.55C373.21,229.74,373.32,230,373.25,230.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,237.9a7,7,0,0,1,1.72-.28c.27,0,.52-.07.57-.26a1.32,1.32,0,0,0-.17-.8c-.24-.65-.49-1.34-.76-2.06a35.41,35.41,0,0,1-1.69-5.4,35.69,35.69,0,0,1,2.13,5.25l.72,2.07a1.51,1.51,0,0,1,.12,1.06.65.65,0,0,1-.45.39,2,2,0,0,1-.46.06A7.25,7.25,0,0,1,377,237.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,227.64c-.2.4-1.38.2-2.75.32s-2.51.46-2.76.1c-.12-.18,0-.54.52-.9a4.09,4.09,0,0,1,2.13-.76,4,4,0,0,1,2.21.44C384.86,227.12,385.08,227.45,385,227.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,226.3c-.2.4-1.38.19-2.75.32s-2.51.45-2.77.09c-.11-.17.06-.53.52-.89a4.09,4.09,0,0,1,2.13-.76,4,4,0,0,1,2.22.43C373.11,225.78,373.33,226.11,373.25,226.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.05,240.51a3.38,3.38,0,0,1-2.77-2.17c-.07-.18-.16-.4-.35-.41a.37.37,0,0,0-.32.22,2.19,2.19,0,1,0,3.63,2.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.12,255.29c2.34.11,6.55-17.33,6.23-22.36-.16-2.58.33-4.9-.42-7.11,3.5-1.62,6.46-2.34,5.88-6.15.95,3.21,2.71,3.83,5.76,5.24s9.06.11,12.38.61c.67.1-1.53-2.13-1-2.59a2,2,0,0,0,.33-1.87,8.5,8.5,0,0,0-3.79-5.09,21.65,21.65,0,0,0-6-2.5,23,23,0,0,0-9.35-1.23,26.13,26.13,0,0,0-6.35,2c-2,.84-4.18,1.75-5.52,3.5-1.58,2.07-1.72,4.9-1.39,7.48s1,5.13.93,7.73c-.52,3.26.16-.45.25-.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.38 224.58 386.33 224.57 386.4 224.29 386.45 224.3 386.38 224.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.89,234.63a.32.32,0,0,1,.28-.57.3.3,0,0,1,.1.4A.3.3,0,0,1,372.89,234.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.26,234.69a.29.29,0,0,1-.33-.22.26.26,0,1,1,.51-.13A.28.28,0,0,1,370.26,234.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.25,234.78a.31.31,0,0,1-.39-.48.29.29,0,0,1,.4.08A.29.29,0,0,1,368.25,234.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69,236.59a.31.31,0,1,1,.41,0A.3.3,0,0,1,370.69,236.59Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.45,236.73a.3.3,0,0,1-.41-.06.3.3,0,0,1,0-.42.33.33,0,0,1,.43.48Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.46,234.84a.42.42,0,0,1,0-.38.42.42,0,0,1,.32-.22c.15,0,.27.22.14.46S384.53,235,384.46,234.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.47,234.81a.27.27,0,0,1-.33-.18.27.27,0,0,1,.17-.33.27.27,0,0,1,.33.18A.26.26,0,0,1,382.47,234.81Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.53,235a.25.25,0,0,1-.35-.06.25.25,0,0,1,.07-.35.26.26,0,0,1,.36.06A.26.26,0,0,1,380.53,235Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39,237a.39.39,0,0,1,.12-.37.42.42,0,0,1,.38-.1c.13,0,.17.3,0,.48S383.42,237.18,383.39,237Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,237.06a.31.31,0,0,1-.38-.2.3.3,0,0,1,.11-.4.29.29,0,0,1,.37.19A.31.31,0,0,1,381.88,237.06Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.89,251.08a23.45,23.45,0,0,1-11.22-3.48s2.7,6.47,11.13,5.83Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.39,265.89a1.39,1.39,0,0,1,1.74-.82l.23.07a1.4,1.4,0,1,1-1.95,1.83A1.39,1.39,0,0,1,388.39,265.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.34,260.83a1.4,1.4,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-1.95,1.83A1.39,1.39,0,0,1,400.34,260.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.76,280a1.39,1.39,0,0,1,1.74-.82l.23.07a1.4,1.4,0,1,1-2,1.84A1.42,1.42,0,0,1,381.76,280Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,271.48a1.39,1.39,0,0,1,1.74-.82l.23.07a1.4,1.4,0,1,1-1.95,1.83A1.39,1.39,0,0,1,374,271.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,274.53a1.4,1.4,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-2,1.83A1.39,1.39,0,0,1,400.44,274.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,263.92a1.4,1.4,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-1.94,1.83A1.44,1.44,0,0,1,360.46,263.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.88,279.15a1.4,1.4,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-2,1.83A1.39,1.39,0,0,1,363.88,279.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.23,298.46a1.4,1.4,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-1.94,1.84A1.37,1.37,0,0,1,385.23,298.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.48,272a1.4,1.4,0,0,1,1.75-.82l.22.07A1.4,1.4,0,1,1,353.5,273,1.39,1.39,0,0,1,353.48,272Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,257.71a1.42,1.42,0,0,1,1.75-.82l.22.07a1.42,1.42,0,1,1-2,.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.24,290.83A1.39,1.39,0,0,1,377,290l.23.07a1.4,1.4,0,1,1-1.95,1.83A1.39,1.39,0,0,1,375.24,290.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.65,299.37a1.39,1.39,0,0,1,1.74-.82l.23.07a1.4,1.4,0,1,1-1.95,1.84A1.42,1.42,0,0,1,366.65,299.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.48,315.88a1.42,1.42,0,0,1,1.75-.82l.22.07a1.42,1.42,0,1,1-2,.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49,262.51a1.41,1.41,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-1.94,1.83A1.44,1.44,0,0,1,346.49,262.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,278.26a1.4,1.4,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-1.95,1.84A1.42,1.42,0,0,1,344.16,278.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.81,290.83a1.4,1.4,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-1.94,1.83A1.44,1.44,0,0,1,357.81,290.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.85,308.1a1.39,1.39,0,0,1,1.74-.82l.23.07a1.4,1.4,0,1,1-1.95,1.83A1.39,1.39,0,0,1,356.85,308.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.19,316.23a1.4,1.4,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-2,1.83A1.39,1.39,0,0,1,384.19,316.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.66,299.11a1.39,1.39,0,0,1,1.74-.82l.23.07a1.4,1.4,0,1,1-1.95,1.83A1.39,1.39,0,0,1,350.66,299.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.6,309.45a1.4,1.4,0,0,1,1.75-.82l.22.07a1.4,1.4,0,1,1-1.95,1.84A1.42,1.42,0,0,1,375.6,309.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 366.6,
    width: 5.56,
    height: 94.94,
    transform: "translate(669.57 828.15) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.22,
    y: 366.83,
    width: 6.92,
    height: 94.81,
    transform: "translate(821.35 828.46) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.94,
    y: 415.67,
    width: 76.83,
    height: 4.57,
    transform: "translate(748.72 835.92) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.19,415.17l.39-6.85-12.82-.82-.68,10,.79.1c3.52.42,17.95,1.9,20.36,1.34C378.92,418.32,368.19,415.17,368.19,415.17Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M359.73,417.71a4.45,4.45,0,0,0-4.39-4l-.24,3.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M373.42,416.9s3.74,1.34,3.23,1.94-15.15-.35-21.57-1.33l0-.29,17.06,1.25S372.67,416.88,373.42,416.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M354.92,417.2l.22,0,.63.08,2.32.25c2,.2,4.68.44,7.68.63s5.73.32,7.7.38l2.34.05h.86l-.22,0-.64,0-2.33-.1c-2-.09-4.69-.23-7.7-.42s-5.72-.42-7.68-.59l-2.33-.2-.63-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.16,418.67a5.5,5.5,0,0,1,.51-1.08,4.91,4.91,0,0,1,.85-.84,1.68,1.68,0,0,0-1,.75A1.74,1.74,0,0,0,372.16,418.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.5,416.51s.23-.18.44-.47a1.38,1.38,0,0,0,.31-.55s-.23.18-.44.46S368.47,416.48,368.5,416.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.5,415.89s.24-.09.47-.27.4-.36.38-.39-.24.08-.47.27S367.48,415.86,367.5,415.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.92,414.64a1.65,1.65,0,0,0,.67.13,1.47,1.47,0,0,0,.67,0,1.52,1.52,0,0,0-.66-.13A1.74,1.74,0,0,0,366.92,414.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.75,413.77a1.89,1.89,0,0,0,1.51.22,3.25,3.25,0,0,0-.75-.11A5,5,0,0,0,366.75,413.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,415.42a2.55,2.55,0,0,0,.83.05,5.65,5.65,0,0,0,.88-.14,2.86,2.86,0,0,0,.52-.17.46.46,0,0,0,.22-.25.33.33,0,0,0-.1-.33,1.52,1.52,0,0,0-1.9.32,1.39,1.39,0,0,0-.3.53c-.05.14-.05.22,0,.22a2.47,2.47,0,0,1,.42-.68,1.52,1.52,0,0,1,.73-.41,1.29,1.29,0,0,1,1,.13c.13.11.06.26-.09.33a2.64,2.64,0,0,1-.47.17,5.88,5.88,0,0,1-.86.17C369.33,415.41,369,415.39,369,415.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,415.47a.78.78,0,0,0,.13-.56,1.28,1.28,0,0,0-.18-.62.83.83,0,0,0-.66-.46.33.33,0,0,0-.28.36.9.9,0,0,0,.12.38,2.47,2.47,0,0,0,.35.52,1.4,1.4,0,0,0,.45.37s-.15-.16-.36-.44a2.31,2.31,0,0,1-.31-.52c-.11-.18-.16-.49,0-.52s.4.21.52.39a1.39,1.39,0,0,1,.19.55A2.46,2.46,0,0,1,369.22,415.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.41,413.71s.36,0,.94.1a4.19,4.19,0,0,1,2,1,4.08,4.08,0,0,1,1.17,1.91c.16.56.16.93.19.93a.76.76,0,0,0,0-.26,3.92,3.92,0,0,0-1.27-2.69,3.89,3.89,0,0,0-2.1-1,3.72,3.72,0,0,0-.71,0C355.5,413.68,355.4,413.7,355.41,413.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08,408.47a22.41,22.41,0,0,0-.28,2.62,21.85,21.85,0,0,0-.13,2.64,22.77,22.77,0,0,0,.28-2.63A21.72,21.72,0,0,0,357.08,408.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.43,416.56a7.29,7.29,0,0,0,1.86.31,7.19,7.19,0,0,0,1.88,0s-.84,0-1.87-.13S361.43,416.52,361.43,416.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.91,416.39s.06.19.14.38.1.37.15.37.08-.19,0-.42S358.94,416.37,358.91,416.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,415.16s0,.16.17.31.25.23.28.2,0-.16-.16-.31S358.08,415.13,358,415.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.72,414.53s.18.05.37.13.31.19.34.16-.06-.21-.29-.3S356.71,414.49,356.72,414.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.78,414.21s.05.11.15.16.2.06.22,0,0-.11-.15-.16S355.79,414.17,355.78,414.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.63,415l.39-6.85-12.82-.82-.68,10,.79.1c3.53.42,17.95,1.9,20.36,1.34C405.36,418.15,394.63,415,394.63,415Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M386.17,417.54a4.4,4.4,0,0,0-1.46-2.84,4.35,4.35,0,0,0-2.93-1.13l-.23,3.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M399.86,416.72s3.75,1.35,3.23,1.95-15.15-.35-21.57-1.33l0-.29,17.06,1.25S399.11,416.71,399.86,416.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M381.36,417a.74.74,0,0,0,.22,0l.63.08,2.32.25c2,.2,4.68.44,7.68.63s5.73.32,7.7.38l2.34,0h.86l-.22,0-.64,0-2.33-.1c-2-.09-4.69-.23-7.7-.42s-5.71-.42-7.68-.59l-2.33-.2-.63,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.6,418.5a5.5,5.5,0,0,1,.51-1.08,5.34,5.34,0,0,1,.85-.84,1.71,1.71,0,0,0-1,.75A1.74,1.74,0,0,0,398.6,418.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,416.34s.23-.19.43-.47.35-.53.31-.55-.23.18-.43.46S394.91,416.31,395,416.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.94,415.72s.24-.09.47-.27.41-.36.38-.39-.24.08-.47.27S393.92,415.69,393.94,415.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.36,414.47a1.65,1.65,0,0,0,.67.13,1.47,1.47,0,0,0,.67,0,1.52,1.52,0,0,0-.66-.13A1.74,1.74,0,0,0,393.36,414.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.19,413.6a1.31,1.31,0,0,0,.74.27c.43.06.78,0,.77-.06a4.65,4.65,0,0,0-.75-.1A5,5,0,0,0,393.19,413.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.45,415.25a2.55,2.55,0,0,0,.83.05,5.75,5.75,0,0,0,.89-.14,3,3,0,0,0,.51-.17.42.42,0,0,0,.22-.25.31.31,0,0,0-.1-.33,1.52,1.52,0,0,0-1.9.32,1.39,1.39,0,0,0-.3.53c-.05.14-.05.22,0,.22a2.47,2.47,0,0,1,.42-.68,1.51,1.51,0,0,1,.74-.41,1.27,1.27,0,0,1,1,.13c.13.11.07.26-.08.33a3.06,3.06,0,0,1-.48.17,5.64,5.64,0,0,1-.86.17C395.77,415.24,395.45,415.22,395.45,415.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.66,415.3a.78.78,0,0,0,.13-.56,1.28,1.28,0,0,0-.18-.62.82.82,0,0,0-.66-.46.33.33,0,0,0-.28.36.9.9,0,0,0,.12.38,2.47,2.47,0,0,0,.35.52c.25.27.44.38.45.36s-.15-.15-.36-.43a2.75,2.75,0,0,1-.31-.52c-.1-.18-.16-.49.05-.52s.4.21.52.39a1.6,1.6,0,0,1,.2.55A2.14,2.14,0,0,1,395.66,415.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85,413.54s.37,0,.94.1a4,4,0,0,1,3.19,2.89c.16.56.15.93.18.93a.76.76,0,0,0,0-.26,3.92,3.92,0,0,0-1.27-2.69,3.89,3.89,0,0,0-2.1-1,3.72,3.72,0,0,0-.71,0A.67.67,0,0,0,381.85,413.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.52,408.3a22.41,22.41,0,0,0-.28,2.62,24.54,24.54,0,0,0-.13,2.64,20.39,20.39,0,0,0,.28-2.63A21.72,21.72,0,0,0,383.52,408.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.87,416.39a7.41,7.41,0,0,0,1.86.31,7.19,7.19,0,0,0,1.88,0c0-.05-.84-.05-1.87-.13S387.88,416.35,387.87,416.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.36,416.22s.05.19.13.38.11.37.15.37.08-.19,0-.42S385.39,416.2,385.36,416.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.49,415s0,.16.16.3.25.24.28.21,0-.16-.16-.31S384.52,415,384.49,415Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.17,414.36s.17.05.36.13.31.19.34.16-.06-.21-.28-.3S383.16,414.32,383.17,414.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.22,414s0,.11.15.16.21.06.22,0,0-.11-.15-.16S382.24,414,382.22,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.55,337.56h2a10.33,10.33,0,0,1,10.33,10.33v64a0,0,0,0,1,0,0H352.22a0,0,0,0,1,0,0v-64A10.33,10.33,0,0,1,362.55,337.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,321.58s14.75,11.6,14.11,29.38H352.22s-5.72-15.69-6.35-20.4c-.82-6.29,1.81-8.39,1.81-8.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.52,413.58l-22.46-.81.61-65.58A11.33,11.33,0,0,1,391,335.86h0a11.34,11.34,0,0,1,11.34,11.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.6,329.37a4.16,4.16,0,0,1,.55.8c.32.53.77,1.31,1.32,2.27l1.92,3.4a28.27,28.27,0,0,1,2.08,4.34,20.08,20.08,0,0,1,1,8.65c-.08,1.11-.2,2-.29,2.62a3.22,3.22,0,0,1-.2.95c-.08,0,0-1.38.13-3.59a21.61,21.61,0,0,0-1.14-8.45,30.94,30.94,0,0,0-2-4.28l-1.82-3.46c-.51-1-.91-1.79-1.18-2.35A3,3,0,0,1,368.6,329.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,353.91a23.83,23.83,0,0,0,5.75,1.85,24.14,24.14,0,0,0,6-.15,4.79,4.79,0,0,1-1.72.57,13.51,13.51,0,0,1-4.39.1,13.31,13.31,0,0,1-4.19-1.34A4.55,4.55,0,0,1,359,353.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.68,407.47c0-.15,4.87-.27,10.87-.27s10.88.12,10.88.27-4.87.26-10.88.26S352.68,407.61,352.68,407.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.31,408.25c0-.14,5-.26,11.14-.26s11.14.12,11.14.26-5,.26-11.14.26S379.31,408.39,379.31,408.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.54,352.44a1.26,1.26,0,0,1-.06-.43c0-.28,0-.7,0-1.24a18.82,18.82,0,0,1,.58-4.53,14.44,14.44,0,0,1,3.09-6,11.89,11.89,0,0,1,3.14-2.56,10.44,10.44,0,0,1,4.16-1.24,10.72,10.72,0,0,1,7.86,2.46,9.52,9.52,0,0,1,2.18,2.95,16.62,16.62,0,0,1,1.13,3,25.54,25.54,0,0,1,.78,4.5c0,.53.06.95.06,1.24a1.44,1.44,0,0,1,0,.43,46,46,0,0,0-1.18-6.07,17.7,17.7,0,0,0-1.15-2.87,9.24,9.24,0,0,0-2.11-2.78,10.43,10.43,0,0,0-14.49,1.29,14.58,14.58,0,0,0-3.1,5.81,22.17,22.17,0,0,0-.73,4.44C379.58,351.85,379.58,352.44,379.54,352.44Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.36,249.7l4.33.66c4,.26,6.2.55,7.47-.31,1.7-1.16-.1-2.87-.1-2.87s3-.51,3-2.28c0-1.21-1.31-1.57-1.31-1.57s2.67-.57,3.34-1.53c.91-1.31-.74-2.36-.74-2.36,3.77-1.55,3.8-3.69,3-4s-3.63.46-3.63.46c-2.35.27-8.81,1.14-6-1.88s3.88-6.4,3.52-7.51a1.29,1.29,0,0,0-2.44.19,15.24,15.24,0,0,1-2.22,3.53,10.07,10.07,0,0,1-2.48,2.26c-1.11.7-2.07,1.25-2.9,1.7l-4.46,3.08Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.79,241.05c-.13.12-.57-.12-1.26-.61s-1.64-1.25-2.86-2a6.88,6.88,0,0,0-4.37-1.09,10.09,10.09,0,0,0-5.11,2.42,8.21,8.21,0,0,0-2.73,4.81,9,9,0,0,0,.6,4.63c1.05,2.59,2.58,3.8,2.33,4.12-.1.12-.6,0-1.35-.5a8.87,8.87,0,0,1-2.58-2.83,9.72,9.72,0,0,1-1.3-5.69,9.91,9.91,0,0,1,3.36-6.41,11.34,11.34,0,0,1,6.58-2.86,7.42,7.42,0,0,1,3.25.54,9.19,9.19,0,0,1,2.34,1.41,13.71,13.71,0,0,1,2.54,2.74C324.72,240.47,324.91,240.93,324.79,241.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.79,241.05c.15,0-.25-.91-1.37-2.18a13.16,13.16,0,0,0-2.27-2.09,8,8,0,0,0-3.71-1.49,10.76,10.76,0,0,0-9.14,4.31,9.05,9.05,0,0,0-1.91,5.75,9.54,9.54,0,0,0,2.39,6,8.27,8.27,0,0,0,1.24,1.13,5.73,5.73,0,0,0,.7.43l.35.15.16,0s0,0-.06.07,0,0-.11-.13l-.23-.33-.5-.69a13.35,13.35,0,0,1-.9-1.44,9.43,9.43,0,0,1-1.16-6.28,8.56,8.56,0,0,1,3-4.92,10.36,10.36,0,0,1,4.57-2.16,6.36,6.36,0,0,1,4.1.68,18,18,0,0,1,2.63,1.71c.68.52,1.2.93,1.58,1.17s.6.26.6.24-.05.07-.17,0a1.73,1.73,0,0,1-.49-.2,17.4,17.4,0,0,1-1.64-1.09,19.32,19.32,0,0,0-2.64-1.62,6.05,6.05,0,0,0-3.9-.58,10.08,10.08,0,0,0-4.36,2.13,8.17,8.17,0,0,0-2.85,4.68,9,9,0,0,0,1.14,6,14.45,14.45,0,0,0,.87,1.38l.5.68.25.37a1.45,1.45,0,0,1,.12.22.48.48,0,0,1,0,.43.38.38,0,0,1-.25.19.59.59,0,0,1-.18,0,1.07,1.07,0,0,1-.27-.06,2.75,2.75,0,0,1-.43-.17,5,5,0,0,1-.77-.48,8.44,8.44,0,0,1-1.33-1.2,10,10,0,0,1-2.51-6.38,9.45,9.45,0,0,1,2-6.05,11.08,11.08,0,0,1,9.56-4.39,8.28,8.28,0,0,1,3.84,1.62,12.77,12.77,0,0,1,2.25,2.2,9.42,9.42,0,0,1,1.11,1.64,1.62,1.62,0,0,1,.17.5C324.86,241,324.79,241.06,324.79,241.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.64,238.18a.73.73,0,0,0,.24-1,1.51,1.51,0,0,0-.93-.64c-1.53-.46-3.17.16-4.65.78a15.94,15.94,0,0,0-4.14,2.24c-.35.29-.7.71-.57,1.15a1.09,1.09,0,0,0,.82.65,3.36,3.36,0,0,0,2.47-.26,6.54,6.54,0,0,0-3.15,1.63,1.49,1.49,0,0,0-.58,1.1,1.12,1.12,0,0,0,1.1.89,3.28,3.28,0,0,0,1.47-.43,5.14,5.14,0,0,0-2.87,1.29,1.26,1.26,0,0,0-.47.75c-.07.6.62,1,1.22,1.06a10.83,10.83,0,0,1,1.8,0,3.83,3.83,0,0,0-3.2,1.48c-.28.37-.48.93-.16,1.27a1.16,1.16,0,0,0,.84.26l1.29,0a6.3,6.3,0,0,0,2.08-.15,2.19,2.19,0,0,0,1.51-1.34,1.34,1.34,0,0,0-.84-1.67,4,4,0,0,0,2.31-1.47,1.61,1.61,0,0,0-.59-2.35c.78-.92,2.51-.75,3-1.85.33-.73-.13-1.56-.57-2.24a3.71,3.71,0,0,0,2.72-1.45",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,239.47a8.6,8.6,0,0,1-2.13,1,20.43,20.43,0,0,1-2.45.78,12.92,12.92,0,0,1-1.52.27,2.43,2.43,0,0,1-.88-.06,1.21,1.21,0,0,1-.79-.65,1.52,1.52,0,0,1,.58-1.73,7.22,7.22,0,0,1,1.38-.74l2.32-1.05a10.24,10.24,0,0,1,2.19-.84,10.25,10.25,0,0,1-2,1.18l-2.27,1.16a7.68,7.68,0,0,0-1.26.7,1,1,0,0,0-.41,1.11c.14.35.65.44,1.13.39a11.24,11.24,0,0,0,1.45-.23,23.77,23.77,0,0,0,2.43-.65A12.86,12.86,0,0,1,316.4,239.47Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.36,243.25a5.57,5.57,0,0,1-1.63.63l-1.82.54-1.08.31a2.12,2.12,0,0,1-1.34,0,1,1,0,0,1-.55-.57,1,1,0,0,1,0-.76,2.27,2.27,0,0,1,.84-.91,9,9,0,0,1,1.66-1,3.57,3.57,0,0,1,1.69-.48,12.39,12.39,0,0,1-1.52.82,11.58,11.58,0,0,0-1.53,1,1.88,1.88,0,0,0-.65.71.46.46,0,0,0,.25.65c.57.23,1.43-.16,2.09-.28l1.82-.42A5.93,5.93,0,0,1,314.36,243.25Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.52,246.71a3.87,3.87,0,0,1-1.8.78,7.92,7.92,0,0,1-2.14.23,1.81,1.81,0,0,1-1.29-.53,1.18,1.18,0,0,1-.33-.76,1.15,1.15,0,0,1,.32-.8,3.72,3.72,0,0,1,1.23-.73l1.16-.47c.74-.29,1.42-.51,2-.68a5.65,5.65,0,0,1,1.9-.4,8.47,8.47,0,0,1-1.78.76c-.56.21-1.21.47-1.94.78l-1.13.49a3.3,3.3,0,0,0-1,.62.58.58,0,0,0,0,.84,1.37,1.37,0,0,0,.94.39,9.28,9.28,0,0,0,2-.11C311.8,246.92,312.49,246.63,312.52,246.71Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.49,250.54s-.13.07-.32,0a.94.94,0,0,1-.52-.71,1.46,1.46,0,0,1,.44-1.23,3.19,3.19,0,0,1,1.28-.75,10.45,10.45,0,0,1,3.54-.91,15.6,15.6,0,0,1-3.32,1.4,3.13,3.13,0,0,0-1.15.62,1.12,1.12,0,0,0-.41.83C307.06,250.33,307.52,250.48,307.49,250.54Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.52 231.39 295.28 270 319.75 288.49 341.65 247.56 347.48 243.55 329.52 231.39",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.52,231.39a1.54,1.54,0,0,1,.31.18l.92.6,3.56,2.36,13.27,8.87.22.15-.22.15-5.81,4,.06-.07c-5.91,11.09-13.52,25.35-21.85,41l-.14.27-.24-.18-2.83-2.14-21.63-16.37-.22-.16.18-.2c10-11.26,18.66-20.9,24.76-27.75l7.12-7.91,1.89-2.09.49-.53.16-.16a1.55,1.55,0,0,1-.16.2l-.48.57L327,234.33l-7,8-24.49,27.79,0-.36,21.65,16.35,2.83,2.13-.39.09c8.37-15.59,16-29.83,22-40.9l0-.05,0,0,5.84-4v.3l-13.08-9-3.54-2.45-.92-.64A3,3,0,0,1,329.52,231.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4,269.25c.77-2.42,3-4,5.3-5.19s4.74-2,6.59-3.78c2-1.88,3.31-4.74,5.91-5.69s5.23.3,7.85,0c4.75-.56,7.81-5.81,12.51-6.66.59-.11,1.33-.07,1.62.45s0,1.07-.28,1.55L322,278c-1,1.77-2.34,3.75-4.37,3.87a6.28,6.28,0,0,1-3.66-1.47l-15.75-10.78",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.09,293.27l-7.21,13.31c-7.08,15.32-2,33.84,12.32,42.72A23.35,23.35,0,0,0,161.66,353c23.38,1.67,52.75.79,52.75.79l27.11,97.93,26.41-4S244.31,338.6,240.41,330.8s-67.48-22.5-67.48-22.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,386.21l0,0c-.06,0,0-.05-.07-.1l-.16-.44-.54-1.68-1.9-6.22c-1.57-5.32-3.7-12.57-6.06-20.58-1-3.45-2-6.76-2.83-9.79l.23.18L197.61,347l-4.17-.22-1.1-.08c-.25,0-.39,0-.38-.06a1.59,1.59,0,0,1,.38,0h1.11l4.17.08,14.48.43h.17l0,.17c.89,3,1.86,6.33,2.86,9.78,2.3,8,4.39,15.28,5.92,20.62.72,2.59,1.31,4.72,1.73,6.26q.28,1.05.45,1.71l.11.45c0,.05,0,.09,0,.12S223.38,386.2,223.39,386.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.07,451.28,265.29,440l-21.15,5.07,3.9,16.54,1.33-.23c5.91-1.08,30-5.89,33.61-8C287,451,268.07,451.28,268.07,451.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.4,451.47s6.73.3,6.2,1.53-24.69,7-35.56,8.62l-.08-.48,28.22-6.5S276.18,451.82,277.4,451.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,461.2a1.56,1.56,0,0,0,.38,0l1.05-.19,3.89-.76c3.27-.65,7.79-1.63,12.74-2.81s9.43-2.35,12.65-3.24l3.81-1.08,1-.31.35-.12a1.48,1.48,0,0,0-.37.07l-1,.26-3.83,1c-3.23.84-7.7,2-12.66,3.17s-9.46,2.18-12.72,2.88l-3.87.84-1.05.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.26,455a9.12,9.12,0,0,1,.27-2,8.67,8.67,0,0,1,1-1.78,3.48,3.48,0,0,0-1.23,3.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.26,453.3c.07,0,.28-.42.47-1a2.3,2.3,0,0,0,.22-1.06c-.07,0-.28.41-.47,1A2.28,2.28,0,0,0,269.26,453.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33,452.8c.06,0,.34-.26.62-.68s.47-.78.41-.82-.34.26-.62.67S267.27,452.76,267.33,452.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,451.06a2.55,2.55,0,0,0,1.14-.12,2.51,2.51,0,0,0,1.07-.38,2.5,2.5,0,0,0-1.13.12A2.59,2.59,0,0,0,265.77,451.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.06,449.74a3.13,3.13,0,0,0,2.55-.41,7.23,7.23,0,0,0-1.27.22A7.62,7.62,0,0,0,265.06,449.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.53,451.28a3.94,3.94,0,0,0,1.36-.33,7.77,7.77,0,0,0,1.37-.67,4.24,4.24,0,0,0,.75-.54.74.74,0,0,0,.23-.5.55.55,0,0,0-.33-.5,2.6,2.6,0,0,0-3.14,2.48c0,.25,0,.38.06.38a3.81,3.81,0,0,1,.34-1.31,2.46,2.46,0,0,1,1-1,2.15,2.15,0,0,1,1.64-.28c.26.11.23.38,0,.59a4.34,4.34,0,0,1-.69.5,9.53,9.53,0,0,1-1.31.7C270,451.11,269.52,451.24,269.53,451.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.9,451.26a1.39,1.39,0,0,0-.07-1,2.22,2.22,0,0,0-.61-.9,1.36,1.36,0,0,0-1.29-.42.54.54,0,0,0-.27.72,1.52,1.52,0,0,0,.37.55,3.9,3.9,0,0,0,.84.67,2,2,0,0,0,.91.37s-.33-.18-.8-.52a5.07,5.07,0,0,1-.77-.68c-.25-.24-.5-.73-.18-.87s.76.14,1,.36a2.24,2.24,0,0,1,.6.79A4.88,4.88,0,0,1,269.9,451.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,455.31c0,.05.59-.2,1.57-.32a6.82,6.82,0,0,1,6.6,3.09c.54.83.72,1.44.76,1.42s0-.16-.1-.43A6,6,0,0,0,255,458a6.63,6.63,0,0,0-6.78-3.18,5.2,5.2,0,0,0-1.16.31A1.29,1.29,0,0,0,246.67,455.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.76,446a38.35,38.35,0,0,0,.85,4.38,37.21,37.21,0,0,0,1.12,4.34,39.32,39.32,0,0,0-.86-4.39A37.27,37.27,0,0,0,246.76,446Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.83,456.91a17.8,17.8,0,0,0,6.2-1.42c0-.07-1.39.35-3.1.73S257.82,456.84,257.83,456.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.69,457.9c0,.06.18.26.4.55s.36.54.43.52,0-.36-.23-.68S253.72,457.84,253.69,457.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,456.33c0,.06.15.25.42.42s.52.25.56.19-.15-.25-.42-.42S251.7,456.27,251.66,456.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,456c0,.07.31,0,.65,0s.6.15.64.08-.2-.31-.62-.34S249.17,455.91,249.21,456Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,455.94c0,.07.14.15.33.17s.35,0,.36-.08-.13-.15-.33-.18S247.53,455.86,247.52,455.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "246.43 454.77 267.61 449.33 266.96 446.8 245.54 451 246.43 454.77"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,441.71l5-9.89-18.47-9.49-7.47,14.39,1.1.66c4.95,2.9,25.37,14.41,29.31,15.13C186.5,453.31,172.63,441.71,172.63,441.71Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.27,447.65s4.68,4.41,3.53,5-22.23-10.3-31.1-15.9l.24-.4,24.47,12.87S178.17,447.14,179.27,447.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.65,436.16l.3.2.89.52,3.28,1.87c2.78,1.56,6.65,3.67,11,5.9s8.29,4.17,11.17,5.53l3.43,1.59.94.41.33.13a1.17,1.17,0,0,0-.31-.17l-.92-.46L178.34,450c-2.86-1.41-6.81-3.36-11.13-5.59s-8.21-4.31-11-5.83l-3.32-1.81-.9-.48A1.28,1.28,0,0,0,151.65,436.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.26,449.47a8.28,8.28,0,0,1,1.45-1.28,8.13,8.13,0,0,1,1.8-.69,2.69,2.69,0,0,0-1.93.48A2.8,2.8,0,0,0,176.26,449.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.24,443.9c0,.06.45-.12.94-.41s.86-.56.82-.62-.46.12-.95.41S172.2,443.84,172.24,443.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.15,442.34c0,.07.41,0,.87-.1s.83-.27.81-.34-.41,0-.87.1S171.13,442.28,171.15,442.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.1,440.11c0,.07.37.34.9.62a2.48,2.48,0,0,0,1,.4c0-.06-.37-.34-.9-.62A2.53,2.53,0,0,0,171.1,440.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.41,438.72s.31.5.91.86a2.1,2.1,0,0,0,1.19.43,80,80,0,0,1-2.1-1.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.69,442.62a4.08,4.08,0,0,0,1.19.6,8.17,8.17,0,0,0,1.41.37,3.41,3.41,0,0,0,.87.07.72.72,0,0,0,.49-.21.54.54,0,0,0,.06-.57,2.46,2.46,0,0,0-3.81-.16.85.85,0,0,0-.2.31,3.8,3.8,0,0,1,1.06-.73,2.33,2.33,0,0,1,1.36-.14,2.06,2.06,0,0,1,1.36.82c.12.24-.07.42-.34.44a3.78,3.78,0,0,1-.82-.06,9.24,9.24,0,0,1-1.38-.31C174.16,442.81,173.71,442.58,173.69,442.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,442.83a1.32,1.32,0,0,0,.56-.75,2.24,2.24,0,0,0,.12-1,1.33,1.33,0,0,0-.68-1.12.53.53,0,0,0-.64.36,1.32,1.32,0,0,0-.07.64,3.87,3.87,0,0,0,.19,1c.18.56.4.85.43.83s-.13-.33-.26-.88a4.37,4.37,0,0,1-.13-1c0-.34.08-.85.41-.75s.46.58.52.91a2.05,2.05,0,0,1-.06.94A5.88,5.88,0,0,1,174,442.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,431.3s.56.22,1.34.75a6.53,6.53,0,0,1,2.85,6.34c-.13.94-.37,1.49-.33,1.5s.09-.12.19-.37a4.69,4.69,0,0,0,.31-1.1,6.32,6.32,0,0,0-2.92-6.52,6.15,6.15,0,0,0-1-.5A1.65,1.65,0,0,0,154.63,431.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5,424.6a72.74,72.74,0,0,0-4,7.54,38.63,38.63,0,0,0,2.11-3.71A36.78,36.78,0,0,0,160.5,424.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.71,439.41a12.29,12.29,0,0,0,2.56,1.65,12,12,0,0,0,2.81,1.18c0-.07-1.21-.62-2.69-1.4S161.75,439.35,161.71,439.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,437.54c-.07,0,0,.31,0,.65s-.08.62,0,.65.25-.25.27-.64S158.16,437.52,158.1,437.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61,435.14c-.07,0-.05.28,0,.57s.22.51.29.49.05-.27-.05-.57S157.68,435.12,157.61,435.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.06,433.36c0,.07.22.2.45.43s.34.48.41.46.05-.35-.23-.63S156.07,433.3,156.06,433.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,432.28c-.05.05,0,.2.13.34s.26.21.31.16,0-.19-.13-.33S154.91,432.24,154.86,432.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "154.75 430.83 173.51 440.01 174.62 437.77 156.03 428.36 154.75 430.83"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "153.9 428.6 175.82 438.73 232.61 358.48 220.62 329.94 190.83 339.87 196.21 358.07 153.9 428.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.09,293.27l-7.21,13.31c-7.08,15.32-2,33.84,12.32,42.72A23.35,23.35,0,0,0,161.66,353c23.38,1.67,52.75.79,52.75.79l27.11,97.93,26.41-4S244.31,338.6,240.41,330.8s-67.48-22.5-67.48-22.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,386.21l0,0c-.06,0,0-.05-.07-.1l-.16-.44-.54-1.68-1.9-6.22c-1.57-5.32-3.7-12.57-6.06-20.58-1-3.45-2-6.76-2.83-9.79l.23.18L197.61,347l-4.17-.22-1.1-.08c-.25,0-.39,0-.38-.06a1.59,1.59,0,0,1,.38,0h1.11l4.17.08,14.48.43h.17l0,.17c.89,3,1.86,6.33,2.86,9.78,2.3,8,4.39,15.28,5.92,20.62.72,2.59,1.31,4.72,1.73,6.26q.28,1.05.45,1.71l.11.45c0,.05,0,.09,0,.12S223.38,386.2,223.39,386.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.87,167.16c7.87-10.36,16.17-8.89,21.92-6.39A15.82,15.82,0,0,1,219,175.85c-.1,1.65-.45,3.39.22,4.91,1.08,2.44,4.23,3.12,6.05,5.07,2.5,2.66,1.95,6.87,1.1,10.41s-1.73,7.6.36,10.59c1.91,2.74,5.55,3.47,8.56,4.93a15.71,15.71,0,0,1,8.31,9.79,13.41,13.41,0,0,1-2.84,12.36c-2.93,3.18-7.31,4.59-11.58,5.22a42.65,42.65,0,0,1-48.82-44.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.68,235.71S251.74,241,248.57,241c-2.46,0-26.68-15-38.8-20.9l-5.8-2.35c-35.66-7.47-41.58,2.16-44.24,7.56-2.42,4.94-.71,21.25-.71,21.25l-.7,28.6-15.58,23c31.45,24,55.77,15.73,55.77,15.73l.6-7.3c.9-14.52,4.34-30.28,6.4-34.93,0,0,9.05-11.78,6.71-23.85,9.46,1.78,31.06,13.47,36.47,13.31,5.1-.15,53.84-8.92,53.84-8.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.45,169.43v3.22l-.21,48.07c0,5.58,4.76,10,10.73,10h0c6,0,11-4.6,11.14-10.24.12-5.91.36-12.14.36-12.14s7.65-1.13,9.4-11.05c.88-4.93.77-13,.47-19.68a10.51,10.51,0,0,0-11.41-10Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,183.68a1.27,1.27,0,0,1-1.25,1.27,1.22,1.22,0,0,1-1.29-1.18,1.27,1.27,0,0,1,1.25-1.26A1.21,1.21,0,0,1,212,183.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.51,181.82c-.16.16-1.12-.57-2.49-.59s-2.39.65-2.54.48.1-.38.54-.69a3.51,3.51,0,0,1,2-.59,3.33,3.33,0,0,1,2,.68C212.45,181.44,212.59,181.75,212.51,181.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,183.45a1.28,1.28,0,0,1-1.25,1.27,1.22,1.22,0,0,1-1.29-1.18,1.27,1.27,0,0,1,1.25-1.26A1.21,1.21,0,0,1,199,183.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,181.83c-.16.17-1.11-.56-2.49-.58s-2.39.64-2.53.47.09-.37.54-.68a3.47,3.47,0,0,1,2-.59,3.36,3.36,0,0,1,2,.68C199,181.46,199.09,181.76,199,181.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.81,192.1a9,9,0,0,1,2.24-.36c.35,0,.68-.09.75-.33a1.91,1.91,0,0,0-.22-1c-.31-.85-.64-1.74-1-2.68-1.37-3.83-2.36-7-2.2-7a46.17,46.17,0,0,1,2.76,6.82l.95,2.71a2,2,0,0,1,.15,1.37.91.91,0,0,1-.58.51,2.77,2.77,0,0,1-.6.07A8.77,8.77,0,0,1,203.81,192.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,208.36a25.3,25.3,0,0,1-13.25-3.79s3.11,6.89,13.08,6.14Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,195.4a2.47,2.47,0,0,0-2.2-1,2.24,2.24,0,0,0-1.57.81,1.43,1.43,0,0,0-.14,1.63,1.64,1.64,0,0,0,1.79.49,5.06,5.06,0,0,0,1.77-1,1.52,1.52,0,0,0,.4-.4.45.45,0,0,0,0-.51",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.76,193c.22,0,.2,1.48,1.45,2.56s2.85.94,2.86,1.15-.36.29-1,.29a3.68,3.68,0,0,1-2.39-.88,3.24,3.24,0,0,1-1.12-2.14C199.48,193.34,199.65,193,199.76,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.24,215.06c3-1,4.16-2,5.32-4.89a14.74,14.74,0,0,0,.37-9.17c-.37-1.39-.9-2.91-.26-4.2a7.78,7.78,0,0,1,2.2-2.19,9.26,9.26,0,0,0,2.94-6.22,16,16,0,0,0-1.14-6.9c-.45-1.22-1-2.55-.54-3.76a5.78,5.78,0,0,1,1.76-2.06,16.37,16.37,0,0,0,3.54-4.56,4.64,4.64,0,0,0,.54-3.94c-.69-1.5-2.56-2-4.21-2.16-3.93-.37-8.3.42-10.86,3.43-2.3,2.7-2.62,6.5-2.84,10-.7,11.13-15.24,22.57-8.12,37.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.46,176.46c-.14.37-1.51.17-3.12.34s-2.93.58-3.13.24c-.1-.16.14-.51.67-.86a5.23,5.23,0,0,1,2.33-.77,5.17,5.17,0,0,1,2.43.33C199.23,176,199.52,176.29,199.46,176.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.07,177.84c-.24.3-1.18,0-2.32-.07s-2.1.17-2.32-.16c-.09-.16.06-.47.49-.76a3.26,3.26,0,0,1,1.9-.47,3.19,3.19,0,0,1,1.84.66C212.06,177.36,212.18,177.69,212.07,177.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.16,310.61l.56.95a110.94,110.94,0,0,0,6.71,10c3.19,3.84,3.55,3.57,3.95,3.13,1.06-1.17-5.35-7-3.24-6.5s7,8,8.06,6.7c1.38-1.66-5.45-7.6-6-8.15s.25-1.32.71-.8c.66.74,7.81,8.37,9.18,6.76.76-.9-1-2.08-1-2.08s-7.22-6.67-6.55-7.41,5.06,3,6.44,4.39,2.59,1.28,2.7.19c.08-.74-4.06-5-5.46-6.37s-5.31-4.91-1.91-4.67,6.1-.83,6.63-1.62-.41-1.78-1.4-1.41a12.87,12.87,0,0,1-3.41.4,8.66,8.66,0,0,1-2.72-.4c-.76-.25-1.43-.49-2-.72l-2.18-.82Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,216a3.59,3.59,0,0,1-.39-.47,13.31,13.31,0,0,1-.94-1.45,16,16,0,0,1-2-6,13.67,13.67,0,0,1,5.88-13.21,27.36,27.36,0,0,0,4.59-3.7,7.37,7.37,0,0,0,1.5-2.49,7.69,7.69,0,0,0,.36-2.81c-.09-1.89-.59-3.7-.8-5.48a13,13,0,0,1,2.23-9.09A13.33,13.33,0,0,1,192,167a10.18,10.18,0,0,1,1.6-.67,2.14,2.14,0,0,1,.59-.15c0,.05-.79.27-2.09,1a13.52,13.52,0,0,0-4.53,4.26,12.71,12.71,0,0,0-2.07,8.82c.22,1.74.73,3.54.84,5.52a8.62,8.62,0,0,1-.37,3,8.07,8.07,0,0,1-1.61,2.66,27.61,27.61,0,0,1-4.68,3.78,13.47,13.47,0,0,0-3.81,3.87,13.87,13.87,0,0,0-2,8.88,16.64,16.64,0,0,0,1.84,6C176.36,215.31,176.88,216,176.83,216Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.29,235s.27-.26.71-.8a7.13,7.13,0,0,0,1.4-2.68,10.06,10.06,0,0,0,0-4.76,11.64,11.64,0,0,0-2.93-5.56,14.05,14.05,0,0,0-2.84-2.35,23,23,0,0,0-3.63-1.75,27.81,27.81,0,0,1-4-1.88,12.32,12.32,0,0,1-3.43-3.18,16.39,16.39,0,0,1-3-9.43,25.46,25.46,0,0,1,.44-5.27c.32-1.76.77-3.51,1.11-5.29a20.38,20.38,0,0,0,.44-3.76,10.23,10.23,0,0,0-.83-3.57c-.46-1.14-1-2.25-1.43-3.4a16.94,16.94,0,0,1-.74-3.57c-.14-1.19-.14-2.36-.27-3.47a20,20,0,0,0-.64-3.26,17.28,17.28,0,0,0-2.63-5.63l0,0h0a11.66,11.66,0,0,0-8.13-5.24,11.16,11.16,0,0,0-7.39,1.54,11.92,11.92,0,0,0-3.61,3.36c-.66.94-.9,1.51-.93,1.5a7.49,7.49,0,0,1,.82-1.58,11.69,11.69,0,0,1,3.59-3.5,11.38,11.38,0,0,1,7.57-1.68,12,12,0,0,1,8.45,5.36v0a17.46,17.46,0,0,1,2.75,5.78,20,20,0,0,1,.66,3.33c.14,1.16.15,2.32.29,3.47a16.29,16.29,0,0,0,.72,3.45c.42,1.12,1,2.23,1.43,3.39a10.71,10.71,0,0,1,.86,3.75,19.37,19.37,0,0,1-.44,3.87c-.34,1.8-.79,3.55-1.11,5.28a25.17,25.17,0,0,0-.44,5.16,15.93,15.93,0,0,0,2.91,9.16,12,12,0,0,0,3.29,3.08,27.16,27.16,0,0,0,3.89,1.87,23.2,23.2,0,0,1,3.67,1.81,13.94,13.94,0,0,1,2.9,2.44,11.83,11.83,0,0,1,2.94,5.75,10.06,10.06,0,0,1-.13,4.88,6.94,6.94,0,0,1-1.52,2.69A4.18,4.18,0,0,1,236.29,235Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.38,235a8.33,8.33,0,0,1,.4,1.46c.23.95.55,2.33.89,4a54.28,54.28,0,0,1,1.25,13.58,23.38,23.38,0,0,1-1.72,7.35,45.7,45.7,0,0,1-2.72,5.51c-.87,1.52-1.6,2.73-2.12,3.55a8.56,8.56,0,0,1-.85,1.26,8.3,8.3,0,0,1,.68-1.36c.51-.94,1.17-2.16,2-3.62a52.15,52.15,0,0,0,2.59-5.52,23.24,23.24,0,0,0,1.65-7.2,60.88,60.88,0,0,0-1.09-13.49c-.29-1.64-.54-3-.72-4.06A7.74,7.74,0,0,1,210.38,235Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.77,231.66a17.78,17.78,0,0,1-1.08,2.92c-.74,1.78-1.78,4.22-3,6.91s-2.29,5.12-3.11,6.86a19.22,19.22,0,0,1-1.42,2.78,17.78,17.78,0,0,1,1.08-2.92c.74-1.78,1.78-4.22,3-6.91s2.28-5.11,3.1-6.85A18.53,18.53,0,0,1,230.77,231.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.09,233.29a103.35,103.35,0,0,1-4.1,9.62,103.9,103.9,0,0,1-4.57,9.41c-.13-.06,1.7-4.36,4.1-9.62A103.9,103.9,0,0,1,234.09,233.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,260.41a1.39,1.39,0,0,1-.45.14l-1.3.31c-.57.13-1.27.27-2.09.39s-1.74.31-2.78.41a63,63,0,0,1-7.3.44,68.46,68.46,0,0,1-8.94-.64,70.53,70.53,0,0,1-8.76-1.9,66.28,66.28,0,0,1-6.9-2.44c-1-.38-1.81-.81-2.56-1.15s-1.39-.67-1.9-.95l-1.18-.64a2,2,0,0,1-.39-.25s.16,0,.44.16l1.22.55c.52.25,1.17.55,1.93.86s1.61.72,2.58,1.07a72.22,72.22,0,0,0,6.89,2.33,74.5,74.5,0,0,0,8.7,1.84,73.6,73.6,0,0,0,8.87.68,70,70,0,0,0,7.26-.33c1-.07,2-.23,2.78-.32s1.52-.21,2.09-.31l1.32-.21A2.38,2.38,0,0,1,211,260.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.28,255a10.17,10.17,0,0,1-1.67.3c-1.09.17-2.66.34-4.61.48a79.45,79.45,0,0,1-15.29-.42A81.41,81.41,0,0,1,175.8,252c-1.86-.62-3.35-1.17-4.36-1.59a10.93,10.93,0,0,1-1.55-.69,10.26,10.26,0,0,1,1.62.5c1,.37,2.53.86,4.4,1.42a91.28,91.28,0,0,0,14.87,3.2,89.58,89.58,0,0,0,15.19.58c1.95-.1,3.53-.21,4.61-.32A9.79,9.79,0,0,1,212.28,255Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.76,222,133.69,261.5a16.05,16.05,0,0,0,3.59,22.23l40.63,29.86,12-13.46L154.53,269.7,178,238.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57,291.3l.57.37,1.62,1.16,6.16,4.45L178,313.41l-.29,0,12-13.47,0,.35L166.15,280l-11.79-10.15-.18-.15.14-.19c5.94-8.24,12.13-15.5,17.07-22.49,1.25-1.75,2.41-3.48,3.51-5.17a40,40,0,0,0,2.71-5.16,23.59,23.59,0,0,0,1.67-5.13,13.44,13.44,0,0,0-.2-4.92,10.42,10.42,0,0,0-4.54-6.84,12,12,0,0,0-6-1.8,6.43,6.43,0,0,0-3.78,1.06,4.93,4.93,0,0,0-.8.65c-.17.16-.26.24-.27.23l.24-.27a4.51,4.51,0,0,1,.78-.69,6.42,6.42,0,0,1,3.83-1.17,12.18,12.18,0,0,1,6.16,1.76,10.62,10.62,0,0,1,4.73,7,13.62,13.62,0,0,1,.24,5,23.15,23.15,0,0,1-1.66,5.23,39.67,39.67,0,0,1-2.72,5.24c-1.1,1.7-2.25,3.44-3.5,5.2-4.94,7-11.11,14.31-17,22.53l0-.34,11.79,10.13L190.08,300l.18.16-.16.18-12,13.44-.13.15-.16-.12-22-16.29-6.08-4.54-1.59-1.2C147.74,291.45,147.57,291.3,147.57,291.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.46,243.36c-.28,9.8-6.58,18.7-6.72,28.5a35.25,35.25,0,0,0,2,11.2c-2.18-1.65-4.54-4.35-7-6,0,0-4.51-4.37-4.45-4.13l.25-8.46,4.38-5.68c-.21.22,11.51-15.42,11.51-15.42"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M166.11,253.84a18.47,18.47,0,0,1-2.67-1.83c-1.6-1.2-3.76-2.93-6.06-4.93s-4.3-3.92-5.7-5.34a18.84,18.84,0,0,1-2.18-2.4,20,20,0,0,1,2.43,2.13c1.47,1.35,3.5,3.21,5.79,5.22s4.41,3.76,5.95,5A23.66,23.66,0,0,1,166.11,253.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.49,250.14a2.83,2.83,0,0,1-.79-.43c-.49-.3-1.18-.77-2-1.36-1.68-1.19-3.95-2.92-6.33-5a80.36,80.36,0,0,1-5.82-5.58c-.71-.75-1.26-1.37-1.63-1.81s-.57-.7-.54-.73a25.53,25.53,0,0,1,2.43,2.28c1.48,1.44,3.54,3.39,5.9,5.44s4.59,3.83,6.21,5.08A24.87,24.87,0,0,1,169.49,250.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.41,
    y: 235.28,
    width: 9.87,
    height: 226.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28,347.19h74.26a8.22,8.22,0,0,1,8.22,8.22V357a8.22,8.22,0,0,1-8.22,8.22H127.28a0,0,0,0,1,0,0v-18A0,0,0,0,1,127.28,347.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.67,
    y: 364.39,
    width: 6.01,
    height: 97.44,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.38,
    y: 415.29,
    width: 74.66,
    height: 3.14,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65,435.87a2.21,2.21,0,0,1,.17-.4c.13-.29.31-.67.54-1.15a30.17,30.17,0,0,0,1.58-4.6,40.63,40.63,0,0,0-.14-17.78A96.33,96.33,0,0,0,63.89,400c-1.4-4.24-3-8.74-4.34-13.59a52.55,52.55,0,0,1-2.14-15.63c.2-5.53,1.83-11,3.63-16.54S64.7,343.38,65.25,338a24.8,24.8,0,0,0-3-15c-2.38-4.39-5.38-8.14-7.62-12a41.8,41.8,0,0,1-4.59-11.56,43.21,43.21,0,0,1-.29-17.92,34.05,34.05,0,0,1,1.87-6.33,1.58,1.58,0,0,1-.11.42c-.09.3-.22.7-.37,1.22A46.21,46.21,0,0,0,50,281.46a43.67,43.67,0,0,0,.47,17.78,41.4,41.4,0,0,0,4.59,11.42c2.24,3.84,5.25,7.58,7.68,12A25.33,25.33,0,0,1,65.81,338c-.56,5.5-2.43,10.91-4.22,16.4S58.17,365.38,58,370.81a52.12,52.12,0,0,0,2.09,15.47c1.3,4.83,2.9,9.33,4.28,13.58a94,94,0,0,1,3.24,12c1.51,7.48,1.08,13.79,0,17.9a26.42,26.42,0,0,1-1.69,4.6l-.59,1.12A2.73,2.73,0,0,1,65,435.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.69,314.74s-4.55-14.57,3.62-23.09a.5.5,0,0,1,.86.25C62.61,294.3,63.15,301.63,57.69,314.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.42,296.5a12.86,12.86,0,0,1-.31,2.69l-1,6.42c-.38,2.4-.72,4.57-1,6.42a13.44,13.44,0,0,1-.49,2.66,12,12,0,0,1,.08-2.71c.16-1.66.45-4,.86-6.46s.85-4.78,1.21-6.41A11.54,11.54,0,0,1,60.42,296.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,349.08s2.79-15,14-18.72a.5.5,0,0,1,.64.63C76.94,333.32,74,340.05,63,349.08Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,334.24a13.35,13.35,0,0,1-1.53,2.23l-3.92,5.19-3.9,5.2A15.17,15.17,0,0,1,63,349a11.31,11.31,0,0,1,1.34-2.36c.91-1.4,2.24-3.28,3.78-5.31s3-3.83,4.06-5.1A11.63,11.63,0,0,1,74,334.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,386.72s-1.69-15.17,8-22a.5.5,0,0,1,.8.41C68.74,367.6,67.88,374.89,60,386.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.17,369.34a13.79,13.79,0,0,1-.81,2.58c-.65,1.75-1.41,3.82-2.25,6.1l-2.22,6.11a13.46,13.46,0,0,1-1,2.52,11.61,11.61,0,0,1,.6-2.64c.47-1.61,1.19-3.8,2.08-6.19s1.74-4.52,2.4-6.05A12,12,0,0,1,66.17,369.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.46,424.57s-1.15-15.21,8.73-21.67a.5.5,0,0,1,.79.44C77.86,405.78,76.74,413,68.46,424.57Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.23,407.42a13,13,0,0,1-.9,2.55l-2.47,6c-.91,2.26-1.74,4.29-2.44,6a13.79,13.79,0,0,1-1.07,2.48,11.33,11.33,0,0,1,.69-2.62c.52-1.58,1.33-3.75,2.3-6.1s1.9-4.46,2.62-6A12.27,12.27,0,0,1,75.23,407.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.15,301.94s-13.53-7.06-13.79-18.87a.5.5,0,0,1,.79-.43C40.16,284,45.73,288.81,51.15,301.94Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.17,287.13a13.81,13.81,0,0,1,1.68,2.11l3.81,5.27,3.83,5.26A15.08,15.08,0,0,1,51,302a11.28,11.28,0,0,1-1.86-2c-1.07-1.28-2.48-3.1-4-5.17s-2.78-4-3.68-5.38A12,12,0,0,1,40.17,287.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.67,333.22s-13.93-6.23-14.91-18a.5.5,0,0,1,.76-.48C53.61,316,59.46,320.44,65.67,333.22Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.81,319.1a13.14,13.14,0,0,1,1.81,2l4.13,5,4.13,5a15.8,15.8,0,0,1,1.68,2.12,10.55,10.55,0,0,1-2-1.85c-1.15-1.21-2.67-2.95-4.28-4.92s-3-3.8-4-5.15A12.85,12.85,0,0,1,53.81,319.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,368.1s-9.57-11.89-5.08-22.81a.5.5,0,0,1,.89-.08C54.76,347.28,58,353.9,57.66,368.1Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.53,350.13a14.12,14.12,0,0,1,.69,2.61l1.39,6.36L57,365.45a15.09,15.09,0,0,1,.53,2.65,11.54,11.54,0,0,1-.92-2.55c-.46-1.6-1-3.84-1.56-6.33s-1-4.75-1.22-6.4A11.61,11.61,0,0,1,53.53,350.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.13,409.15s-13.82-6.46-14.61-18.24a.51.51,0,0,1,.77-.47C55.36,391.74,61.14,396.28,67.13,409.15Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.51,394.84a13.28,13.28,0,0,1,1.77,2l4,5.1,4.06,5.08A14.15,14.15,0,0,1,67,409.21a11.46,11.46,0,0,1-1.94-1.88c-1.13-1.24-2.62-3-4.19-5s-3-3.85-3.92-5.21A11.59,11.59,0,0,1,55.51,394.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.66,349.16a1.37,1.37,0,0,1,0,.34c0,.27,0,.59,0,1,0,.91-.09,2.15-.16,3.7-.18,3.25-.43,7.78-.72,13.21h0v0c-1,5.52-3.8,11.64-7.57,17.58-2.77,4.38-5.68,8.36-8.18,12.06a86.55,86.55,0,0,0-6.14,10.14A42.18,42.18,0,0,0,69,414.64c-.25.91-.43,1.62-.54,2.1a3.67,3.67,0,0,1-.2.74,3.52,3.52,0,0,1,.09-.76c.07-.49.22-1.22.43-2.14A39.61,39.61,0,0,1,71.51,407a81.53,81.53,0,0,1,6.06-10.26C80.06,393,83,389.05,85.7,384.7c3.76-5.91,6.56-11.94,7.58-17.37v0c.38-5.42.7-9.95.93-13.2.12-1.54.22-2.78.29-3.69,0-.39.08-.71.1-1A1.66,1.66,0,0,1,94.66,349.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.43,383.87s5.85-14.09-1.51-23.33a.51.51,0,0,0-.88.17C83.38,363.07,82.18,370.32,86.43,383.87Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.36,365.46a12,12,0,0,1,.47,2.66c.21,1.66.44,3.95.62,6.49s.27,4.85.27,6.52a11,11,0,0,1-.17,2.7,15.06,15.06,0,0,1-.24-2.69c-.12-1.87-.27-4.06-.43-6.49s-.32-4.62-.45-6.49A14,14,0,0,1,85.36,365.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.43,383.87s5.85-14.09-1.51-23.33a.51.51,0,0,0-.88.17C83.38,363.07,82.18,370.32,86.43,383.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.3,417.82S73,403.3,64.9,394.7a.5.5,0,0,0-.86.24C63.58,397.34,63,404.66,68.3,417.82Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.74,399.56a12.08,12.08,0,0,1,.68,2.62c.34,1.63.76,3.9,1.15,6.42s.66,4.8.79,6.47a11.87,11.87,0,0,1,.06,2.71,15.83,15.83,0,0,1-.46-2.67c-.27-1.85-.6-4-1-6.43s-.69-4.58-1-6.43A14.54,14.54,0,0,1,65.74,399.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3,417.82S73,403.3,64.9,394.7a.5.5,0,0,0-.86.24C63.58,397.34,63,404.66,68.3,417.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M93.89,366.65s12.5-8.75,11.23-20.5a.5.5,0,0,0-.83-.33C102.47,347.46,97.57,352.93,93.89,366.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.89,366.65s12.5-8.75,11.23-20.5a.5.5,0,0,0-.83-.33C102.47,347.46,97.57,352.93,93.89,366.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,350.54a12,12,0,0,1-1,2.5c-.71,1.51-1.74,3.56-2.95,5.81s-2.38,4.23-3.27,5.64A11.21,11.21,0,0,1,94,366.68a14.75,14.75,0,0,1,1.24-2.4l3.12-5.71c1.15-2.13,2.2-4.07,3.1-5.72A12.92,12.92,0,0,1,102.86,350.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.34,403.43S88.42,401.08,92.45,390a.5.5,0,0,0-.6-.67C89.5,390,82.69,392.73,73.34,403.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.34,403.43S88.42,401.08,92.45,390a.5.5,0,0,0-.6-.67C89.5,390,82.69,392.73,73.34,403.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M88.49,392.92a11.72,11.72,0,0,1-2,1.79c-1.3,1-3.14,2.43-5.21,3.91s-4,2.75-5.42,3.62a10.76,10.76,0,0,1-2.4,1.27,15.65,15.65,0,0,1,2.17-1.6l5.32-3.76,5.3-3.77A14.17,14.17,0,0,1,88.49,392.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.96 431.17 54.56 460.77 81.97 460.77 78.41 431.17 58.96 431.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.51,440.34a105.61,105.61,0,0,1-11.05.29,105.45,105.45,0,0,1-11-.29c0-.15,4.94-.28,11-.28S79.51,440.19,79.51,440.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.05,442.7a112.57,112.57,0,0,1-11.41.29,112.69,112.69,0,0,1-11.42-.29,112.69,112.69,0,0,1,11.42-.29A112.57,112.57,0,0,1,80.05,442.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.54,277.38c.57.68,4.85,6.52,4.85,6.52h39.36l4.15-6.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.54,277.38s.07,0,.22,0h.7l2.75,0,10.24-.08c8.69-.07,20.86-.16,34.45-.17h.47l-.25.4-1.85,2.92L262,284l-.08.12h-.14c-16.63,0-31-.05-39.36-.12h-.07l0-.05c-1.52-2.1-2.71-3.76-3.55-4.93l-.9-1.26c-.21-.29-.3-.43-.29-.42s.13.15.36.44.56.74,1,1.27l3.62,4.73-.11-.06c8.36-.06,22.73-.11,39.36-.12l-.22.12c.75-1.18,1.52-2.41,2.3-3.65l1.85-2.92.22.4c-13.45,0-25.47-.06-34.19-.11l-10.33-.06-2.83,0h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.67,277.38c.57.68,4.85,6.52,4.85,6.52h39.36l4.15-6.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.67,277.38s.07,0,.22,0h.7l2.75,0,10.24-.08c8.69-.07,20.86-.16,34.45-.17h.47l-.25.4-1.84,2.92L429.1,284l-.08.12h-.14c-16.63,0-31-.05-39.36-.12h-.07l0-.05-3.55-4.93-.9-1.26-.29-.42s.13.15.36.44l1,1.27,3.62,4.73-.11-.06c8.36-.06,22.73-.11,39.36-.12l-.22.12c.75-1.18,1.52-2.41,2.3-3.65.64-1,1.26-2,1.85-2.92l.22.4c-13.45,0-25.46-.06-34.19-.11l-10.33-.06-2.83,0h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.94,277.38c.57.68,4.85,6.52,4.85,6.52h39.36l4.14-6.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.94,277.38s.07,0,.22,0h.7l2.75,0,10.24-.08c8.69-.07,20.86-.16,34.44-.17h.48l-.26.4-1.84,2.92-2.3,3.65-.08.12h-.14c-16.63,0-31-.05-39.36-.12h-.07l-.05-.05-3.54-4.93-.9-1.26c-.21-.29-.3-.43-.29-.42s.13.15.36.44l1,1.27,3.63,4.73-.11-.06c8.36-.06,22.73-.11,39.36-.12l-.22.12c.75-1.18,1.52-2.41,2.3-3.65l1.85-2.92.22.4c-13.45,0-25.47-.06-34.19-.11l-10.33-.06-2.83,0h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.93 259.94 270.14 283.9 285.23 283.9 286.79 259.54 267.93 259.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.93,259.94a1.15,1.15,0,0,1,.32,0l1-.05,3.79-.13,13.76-.41H287v.24c-.4,6.42-.88,14.08-1.39,22.31,0,.69-.09,1.38-.13,2.06l0,.24h-.24l-15.09,0h-.22l0-.22c-.6-7.08-1.11-13.09-1.48-17.38-.17-2.06-.3-3.71-.39-4.9,0-.52-.07-.95-.09-1.28a1.87,1.87,0,0,1,0-.42,4.55,4.55,0,0,1,.07.47c0,.35.09.78.15,1.33.12,1.19.3,2.86.52,4.94.42,4.25,1,10.19,1.71,17.2l-.24-.21,15.09,0-.26.25c0-.69.09-1.37.13-2.06.54-8.23,1-15.89,1.47-22.3l.22.23-13.62.17-3.85,0h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,265.32c-.24,0,1.53,15.83,1.53,15.83h12.61l1.38-15.83s-5.74,1.69-7.9,1.69S274.13,264.93,269.74,265.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.31 259.94 457.52 283.9 472.61 283.9 474.17 259.54 455.31 259.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.3,259.94l.32,0,1-.05,3.79-.13,13.76-.41h.24v.24c-.4,6.42-.88,14.08-1.39,22.31-.05.69-.09,1.38-.13,2.06l0,.24h-.24l-15.09,0h-.22l0-.22c-.6-7.08-1.12-13.09-1.48-17.38-.17-2.06-.3-3.71-.39-4.9,0-.52-.07-.95-.09-1.28s0-.43,0-.42a3.14,3.14,0,0,1,.08.47c0,.35.08.78.15,1.33.12,1.19.3,2.86.52,4.94.42,4.25,1,10.19,1.7,17.2l-.23-.21,15.09,0-.26.25c0-.69.09-1.37.13-2.06.54-8.23,1-15.89,1.47-22.3l.22.23-13.62.17-3.85,0h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.12,265.32c-.24,0,1.53,15.83,1.53,15.83h12.61l1.38-15.83s-5.74,1.69-7.9,1.69S461.51,264.93,457.12,265.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.32 259.94 347.53 283.9 362.62 283.9 364.18 259.54 345.32 259.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.32,259.94a1.15,1.15,0,0,1,.32,0l1-.05,3.79-.13,13.77-.41h.23v.24c-.4,6.42-.87,14.08-1.39,22.31,0,.69-.08,1.38-.13,2.06v.24h-.25l-15.09,0h-.21l0-.22c-.61-7.08-1.12-13.09-1.49-17.38-.16-2.06-.29-3.71-.39-4.9,0-.52-.06-.95-.09-1.28a1.87,1.87,0,0,1,0-.42,4.55,4.55,0,0,1,.07.47c0,.35.09.78.15,1.33.13,1.19.3,2.86.52,4.94.42,4.25,1,10.19,1.71,17.2l-.24-.21,15.09,0-.26.25c.05-.69.09-1.37.13-2.06.55-8.23,1.05-15.89,1.47-22.3l.23.23-13.63.17-3.84,0h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.48,
    y: 289.94,
    width: 7.61,
    height: 171.9,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.76,
    y: 295.58,
    width: 7.61,
    height: 166.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.94,283.9c.29,15.2-.39,31.92-.1,47.12.1,5.16.37,10.76,3.71,14.68,3.61,4.24,9.89,5.22,15.36,4.21s10.48-3.65,15.69-5.62a65.52,65.52,0,0,1,40.24-1.82c15.8,4.36,30,14.68,46.29,16,15,1.22,29.43-5.35,43.37-11.09s29.35-10.85,43.85-6.69c12.86,3.69,22.93,14.19,35.81,17.83,14.76,4.18,30.28-1.29,45-5.53s31.78-7,44.48,1.63c3.79,2.58,6.9,6.32,11.2,7.93,18.7,7,43.19,0,40-18.74V283.9Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M209.94,283.9c.29,15.2-.39,31.92-.1,47.12.1,5.16.37,10.76,3.71,14.68,3.61,4.24,9.89,5.22,15.36,4.21s10.48-3.65,15.69-5.62a65.52,65.52,0,0,1,40.24-1.82c15.8,4.36,30,14.68,46.29,16,15,1.22,29.43-5.35,43.37-11.09s29.35-10.85,43.85-6.69c12.86,3.69,22.93,14.19,35.81,17.83,14.76,4.18,30.28-1.29,45-5.53s31.78-7,44.48,1.63c3.79,2.58,6.9,6.32,11.2,7.93,18.7,7,43.19,0,40-18.74V283.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M594.84,340l-.87.61a19.67,19.67,0,0,1-2.7,1.55,23.9,23.9,0,0,1-11.71,2c-5.22-.31-11.45-2.12-18.13-5.28-3.36-1.54-6.87-3.35-10.65-5.14a69.19,69.19,0,0,0-12.34-4.7,36.28,36.28,0,0,0-7-1.14,42.86,42.86,0,0,0-7.4.21,79.29,79.29,0,0,0-15.33,3.59c-5.2,1.66-10.51,3.63-16.11,5.27s-11.54,3-17.74,2.74a33.71,33.71,0,0,1-9.22-1.62A43.12,43.12,0,0,1,457,334c-5.54-3.33-10.59-7.58-16.19-11.21a69.5,69.5,0,0,0-59.66-7.29,109.58,109.58,0,0,0-18.3,8.83c-5.81,3.32-11.48,6.67-17.36,9.33a59.24,59.24,0,0,1-9,3.25,43,43,0,0,1-4.61,1c-.77.16-1.55.17-2.32.27a20.22,20.22,0,0,1-2.32.15,43.59,43.59,0,0,1-17.57-3.56c-5.4-2.22-10.37-4.95-15.22-7.45A96.43,96.43,0,0,0,280,320.9a35.84,35.84,0,0,0-3.6-1,32.6,32.6,0,0,0-3.6-.69,27.05,27.05,0,0,0-3.57-.32,24.18,24.18,0,0,0-3.51,0,54.66,54.66,0,0,0-12.89,2.76c-4,1.28-7.68,2.65-11.21,3.74a49,49,0,0,1-10.06,2.2,34.79,34.79,0,0,1-8.66-.15,25.06,25.06,0,0,1-6.63-1.92,19,19,0,0,1-4.26-2.75,14.67,14.67,0,0,1-2.12-2.28l-.63-.85s.23.27.67.82a15.41,15.41,0,0,0,2.15,2.23,19.07,19.07,0,0,0,4.25,2.69,25.12,25.12,0,0,0,6.6,1.86,35.4,35.4,0,0,0,8.6.11,50.17,50.17,0,0,0,10-2.23c3.52-1.11,7.22-2.49,11.2-3.79a55.4,55.4,0,0,1,13-2.81,26.12,26.12,0,0,1,3.54,0,27.5,27.5,0,0,1,3.61.32,30.68,30.68,0,0,1,3.64.69,34.73,34.73,0,0,1,3.64,1,96.18,96.18,0,0,1,14.47,6.4c4.86,2.5,9.83,5.22,15.2,7.42a43.53,43.53,0,0,0,17.38,3.51,21.84,21.84,0,0,0,2.29-.16c.76-.1,1.54-.11,2.3-.27a42.94,42.94,0,0,0,4.55-1,58.67,58.67,0,0,0,8.93-3.24c5.85-2.64,11.51-6,17.31-9.31A110,110,0,0,1,381,315a70,70,0,0,1,60.11,7.35c5.63,3.66,10.67,7.9,16.17,11.21a42.06,42.06,0,0,0,8.55,4.07,33.16,33.16,0,0,0,9.09,1.61c6.12.24,12-1.09,17.6-2.7s10.88-3.59,16.09-5.24A79.76,79.76,0,0,1,524,327.73a42.74,42.74,0,0,1,7.48-.2,37.71,37.71,0,0,1,7.06,1.17,69.38,69.38,0,0,1,12.39,4.76c3.78,1.8,7.29,3.62,10.63,5.18,6.65,3.17,12.84,5,18,5.33a24.08,24.08,0,0,0,11.66-1.88,21,21,0,0,0,2.71-1.5C594.53,340.21,594.84,340,594.84,340Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.84,347.87l-.87.61a18.38,18.38,0,0,1-2.71,1.52,22.89,22.89,0,0,1-11.74,1.65c-5.2-.49-11.34-2.47-18-5.58-3.36-1.54-6.87-3.35-10.64-5.14a70.06,70.06,0,0,0-12.32-4.71,38.31,38.31,0,0,0-14.38-1,78.52,78.52,0,0,0-15.32,3.56c-5.2,1.65-10.49,3.62-16.08,5.27s-11.52,3-17.72,2.78a33.39,33.39,0,0,1-9.22-1.57,41.35,41.35,0,0,1-8.66-4.06c-5.55-3.31-10.6-7.55-16.17-11.19a69.7,69.7,0,0,0-59.58-7.52,109,109,0,0,0-18.3,8.79c-5.79,3.3-11.45,6.66-17.32,9.33a49.37,49.37,0,0,1-18.21,4.81A43.43,43.43,0,0,1,310,342c-5.42-2.17-10.38-4.91-15.22-7.41a102.22,102.22,0,0,0-14.36-6.46c-.6-.19-1.19-.41-1.79-.59l-1.81-.46c-.6-.15-1.19-.32-1.79-.44l-1.8-.29c-.59-.09-1.18-.2-1.78-.27l-1.78-.1-1.76-.09-1.74.05a52.82,52.82,0,0,0-12.89,2.65c-4,1.26-7.68,2.64-11.2,3.74a55.54,55.54,0,0,1-10,2.32,34.72,34.72,0,0,1-8.65,0,24,24,0,0,1-6.65-1.83,18.06,18.06,0,0,1-4.25-2.75,15.17,15.17,0,0,1-2.12-2.27c-.42-.56-.62-.86-.62-.86l.67.82a15.23,15.23,0,0,0,2.14,2.23,18.63,18.63,0,0,0,4.24,2.69,23.93,23.93,0,0,0,6.62,1.77,35.35,35.35,0,0,0,8.59-.05,54.42,54.42,0,0,0,10-2.36c3.51-1.11,7.2-2.5,11.19-3.77a53,53,0,0,1,13-2.71l1.76-.05,1.78.09,1.8.09c.6.07,1.2.18,1.8.27l1.82.29c.61.12,1.2.29,1.81.44l1.82.46c.6.18,1.2.39,1.8.59A102.67,102.67,0,0,1,295,334.25c4.85,2.49,9.8,5.22,15.19,7.36A43,43,0,0,0,327.55,345a49.19,49.19,0,0,0,18-4.79c5.84-2.66,11.48-6,17.28-9.33A109.29,109.29,0,0,1,381.23,322a70.19,70.19,0,0,1,60,7.58c5.6,3.67,10.65,7.91,16.15,11.19a41.37,41.37,0,0,0,8.55,4,33.45,33.45,0,0,0,9.09,1.55c6.11.22,12-1.13,17.57-2.74s10.87-3.59,16.08-5.24a78.72,78.72,0,0,1,15.4-3.55,38.82,38.82,0,0,1,14.52,1A70.24,70.24,0,0,1,551,340.63c3.78,1.81,7.28,3.62,10.62,5.17,6.66,3.13,12.76,5.13,17.93,5.65a23.1,23.1,0,0,0,11.68-1.54,19.82,19.82,0,0,0,2.72-1.48C594.53,348.05,594.84,347.87,594.84,347.87Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncCostomer);
export default __webpack_public_path__ + "static/media/inc_costomer.1104113763897a117953138077a90a27.svg";
export { ForwardRef as ReactComponent };